import {
  mapAgentRunFindingsFromApi,
  mapAgentScheduleExecutionDetailFromApi,
  mapAgentScheduleExecutionFromApi,
  mapAgentScheduleFromApi,
  mapAgentScheduleRunFromApi,
} from 'components/MonitoringAgent/utils/mapAgentScheduleFromApi';
import { DATA_SET_PAGINATION_COUNT } from 'constants/dataSets';
import { UNIQUE_IDENTIFIER } from 'constants/formFields';
import {
  HTTP_METHODS, LINK_TYPES, PROPERTY_TYPES, PROPERTY_VALUES,
  SHEET_EXAMPLE_FILES_NAME,
  TASK_SORT_BY,
} from 'constants/general';
import { MONITORING_AGENT_DEMO_SIGNALS } from 'constants/monitoringAgentDemoData';
import {
  VALUE_BALANCE_SHEET_ASSET,
  VALUE_CHAIN_CONNECTION_LOGICAL,
  VALUE_CHAIN_CONNECTION_LOGICAL_CREATE,
  VALUE_CHAIN_CONNECTION_MANUFACTURE,
  VALUE_CHAIN_CONNECTION_MANUFACTURE_CREATE,
  VALUE_CHAIN_CONNECTION_SERVICE,
  VALUE_CHAIN_CONNECTION_SERVICE_CREATE,
  VALUE_CHAIN_CONNECTION_SUPPLIER,
  VALUE_CHAIN_CONNECTION_SUPPLIER_CREATE,
  VALUE_CHAIN_CUSTOMER_DATA,
  VALUE_CHAIN_MAP_AGENT_RUN_FINDINGS,
  VALUE_CHAIN_MAP_AGENT_SCHEDULE,
  VALUE_CHAIN_MAP_AGENT_SCHEDULE_EXECUTION,
  VALUE_CHAIN_MAP_AGENT_SCHEDULE_EXECUTIONS,
  VALUE_CHAIN_MAP_AGENT_SCHEDULE_PAUSE,
  VALUE_CHAIN_MAP_AGENT_SCHEDULE_RESUME,
  VALUE_CHAIN_MAP_AGENT_SCHEDULE_RUN_NOW,
  VALUE_CHAIN_MAP_AGENT_SCHEDULE_RUNS,
  VALUE_CHAIN_MAP_AGENT_SCHEDULES,
  VALUE_CHAIN_MAP_AGENT_SESSION,
  VALUE_CHAIN_MAP_AGENT_SESSION_ACTIVATE,
  VALUE_CHAIN_MAP_AGENT_SESSION_APPLY,
  VALUE_CHAIN_MAP_AGENT_SESSION_BOM,
  VALUE_CHAIN_MAP_AGENT_SESSION_BOM_ALL_TABS_EXPLORE_AI,
  VALUE_CHAIN_MAP_AGENT_SESSION_BOM_EXPLORE_AI,
  VALUE_CHAIN_MAP_AGENT_SESSION_BOM_IMPORT_XLSX,
  VALUE_CHAIN_MAP_AGENT_SESSION_BOM_ITEM,
  VALUE_CHAIN_MAP_AGENT_SESSION_BOM_ITEMS,
  VALUE_CHAIN_MAP_AGENT_SESSION_BOM_LINE_ITEM,
  VALUE_CHAIN_MAP_AGENT_SESSION_BOM_SELECTION,
  VALUE_CHAIN_MAP_AGENT_SESSION_BOM_XLSX_EXAMPLE,
  VALUE_CHAIN_MAP_AGENT_SESSION_CANCEL_REVIEW,
  VALUE_CHAIN_MAP_AGENT_SESSION_DRAFT_COLUMN_STRUCTURE,
  VALUE_CHAIN_MAP_AGENT_SESSION_DRAFT_UNIT,
  VALUE_CHAIN_MAP_AGENT_SESSION_EXECUTION,
  VALUE_CHAIN_MAP_AGENT_SESSION_EXECUTIONS,
  VALUE_CHAIN_MAP_AGENT_SESSION_START,
  VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY,
  VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_ALL_TABS_EXPLORE_AI,
  VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT,
  VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_EXPLORE_AI,
  VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_IMPORT_XLSX,
  VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_ITEM,
  VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_ITEMS,
  VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_SELECTION,
  VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_XLSX_EXAMPLE,
  VALUE_CHAIN_MAP_AGENT_SESSION_UNITS,
  VALUE_CHAIN_MAP_AGENT_SESSIONS,
  VALUE_CHAIN_MAP_AGENT_TEMPLATES_ELIGIBLE,
  VALUE_CHAIN_MAP_ANALYSIS,
  VALUE_CHAIN_MAP_ANALYSIS_BY_ID,
  VALUE_CHAIN_MAP_ANALYSIS_RESULT_BY_ID,
  VALUE_CHAIN_MAP_ANALYSIS_RESULT_COPY,
  VALUE_CHAIN_MAP_ANALYSIS_RESULT_DOWNSTREAM,
  VALUE_CHAIN_MAP_ANALYSIS_RESULTS,
  VALUE_CHAIN_MAP_ANALYSIS_SCENARIO,
  VALUE_CHAIN_MAP_ANALYSIS_SCENARIO_BY_ID,
  VALUE_CHAIN_MAP_ANALYSIS_SCENARIO_COPY,
  VALUE_CHAIN_MAP_ANALYSIS_SCENARIO_CREATE,
  VALUE_CHAIN_MAP_ANALYSIS_SCENARIO_DOWNSTREAM,
  VALUE_CHAIN_MAP_ANALYSIS_START,
  VALUE_CHAIN_MAP_ARCHIVE,
  VALUE_CHAIN_MAP_BOARD,
  VALUE_CHAIN_MAP_BOARD_COLUMN,
  VALUE_CHAIN_MAP_BOARD_COLUMN_NAMES,
  VALUE_CHAIN_MAP_BOARD_FILTERS,
  VALUE_CHAIN_MAP_BOARD_GROUPS,
  VALUE_CHAIN_MAP_BOARD_STRUCTURE,
  VALUE_CHAIN_MAP_BOARD_UNIT,
  VALUE_CHAIN_MAP_BOARD_UNIT_CUSTOMER,
  VALUE_CHAIN_MAP_BOARD_UNIT_PRODUCT,
  VALUE_CHAIN_MAP_BOARD_UNIT_PROFIT_CENTER,
  VALUE_CHAIN_MAP_BOARD_UNIT_SUPPLIER,
  VALUE_CHAIN_MAP_BOARD_UNITS,
  VALUE_CHAIN_MAP_BUSINESS_STRUCTURE,
  VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_ORG_PATH,
  VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_STATUS,
  VALUE_CHAIN_MAP_CREATE,
  VALUE_CHAIN_MAP_DE_ARCHIVE,
  VALUE_CHAIN_MAP_DELETE,
  VALUE_CHAIN_MAP_DETAILS,
  VALUE_CHAIN_MAP_DUPLICATE,
  VALUE_CHAIN_MAP_LIST,
  VALUE_CHAIN_MAP_ORG_STRUCTURE,
  VALUE_CHAIN_MAP_RECORD_REFS,
  VALUE_CHAIN_MAP_REVIEW,
  VALUE_CHAIN_MAP_UPDATE,
  VALUE_CHAIN_MAP_USER_FILTERS,
  VALUE_CHAIN_OWN_OPERATION_DATA,
  VALUE_CHAIN_PRODUCT_DATA,
  VALUE_CHAIN_PROFIT_CENTER_DATA,
  VALUE_CHAIN_SUPPLIER_DATA,
} from 'constants/requestUrls';
import mainApi from 'store/apis/mainApi';
import VC_CUSTOMER_LIST_TAG from 'store/tags/valueChainCustomers';
import VC_AGENT_SESSION_LIST_TAG, {
  VC_AGENT_MONITORING_RESULTS_TAG,
  VC_AGENT_MONITORING_RUN_FINDINGS_TAG,
  VC_AGENT_MONITORING_SCHEDULE_EXECUTIONS_TAG,
  VC_AGENT_MONITORING_SCHEDULE_RUNS_TAG,
  VC_AGENT_MONITORING_SCHEDULES_TAG,
  VC_AGENT_MONITORING_SESSION_EXECUTIONS_TAG,
  VC_AGENT_SESSION_BOM_ITEMS_TAG,
  VC_AGENT_SESSION_BOM_LINE_ITEM_RECORD_TAG,
  VC_AGENT_SESSION_BOM_RECORD_TAG,
  VC_AGENT_SESSION_BOM_TAG,
  VC_AGENT_SESSION_RECORD_TAG,
  VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEM_RECORD_TAG,
  VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEMS_TAG,
  VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG,
  VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG,
  VC_DRAFT_STRUCTURE_TAG,
} from 'store/tags/valueChainSession';
import VC_SUPPLIER_LIST_TAG from 'store/tags/valueChainSuppliers';
import downloadFileHandler from 'utils/downloadFileHandler';
import { paginationForceRefetch, paginationMerge, paginationSerializeQueryArgs } from 'utils/storeHelpers';
import {
  deleteValueChainItemFromList,
  updateValueChainMapList,
  upsertValueChainMapList,
} from 'utils/valueChainApi';
import moveValueChainBoardUnit from 'utils/valueChainBoardUnitPlacement';
import {
  syncBomSelectionInCaches,
  syncCreatedBomItemInCaches,
  syncDeletedBomItemInCaches,
  syncUpdatedBomItemInCaches,
} from 'utils/valueChainBomItemsApi';
import {
  syncCreatedSupplierDiscoveryItemInCaches,
  syncDeletedSupplierDiscoveryItemInCaches,
  syncSupplierDiscoverySelectionInCaches,
  syncUpdatedSupplierDiscoveryItemInCaches,
} from 'utils/valueChainSupplierDiscoveryItemsApi';

import {
  VALUE_CHAIN_MAP_ANALYSES_TAG,
  VALUE_CHAIN_MAP_BOARD_COLUMN_NAMES_TAG,
  VALUE_CHAIN_MAP_BOARD_TAG,
  VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG,
  VALUE_CHAIN_MAP_DETAILS_TAG,
  VALUE_CHAIN_MAP_LIST_TAG,
  VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG,
} from '../../../tags/valueChainMap';

import type IMonitoringExecution from 'constants/interfaces/IMonitoringExecution';
import type { IMonitoringExecutionDetail } from 'constants/interfaces/IMonitoringExecution';
import type IMonitoringRun from 'constants/interfaces/IMonitoringRun';
import type IMonitoringRunFindings from 'constants/interfaces/IMonitoringRunFindings';
import type IMonitoringSchedule from 'constants/interfaces/IMonitoringSchedule';
import type { TMonitoringAnySignalResult } from 'constants/interfaces/IMonitoringSignalResult';
import type ICustomerItem from 'store/slices/dataSets/interfaces/ICustomerItem';
import type IGetOrgStructureResponse from 'store/slices/dataSets/interfaces/IGetOrgStructureResponse';
import type IOwnItem from 'store/slices/dataSets/interfaces/IOwnItem';
import type IProductItem from 'store/slices/dataSets/interfaces/IProductItem';
import type IProfitCenterItem from 'store/slices/dataSets/interfaces/IProfitCenterItem';
import type { IRecordRefsVCRequest } from 'store/slices/dataSets/interfaces/IRecordRefsRequest';
import type { IRecordRefsResponse } from 'store/slices/dataSets/interfaces/IRecordRefsResponse';
import type ISupplierItem from 'store/slices/dataSets/interfaces/ISupplierItem';
import type { IUidNameTuplesResponse } from 'store/slices/dataSets/interfaces/IUidNameTuplesResponse';
import type { IBaseQueryPaginationResponse } from 'store/types/IBaseQueryPaginationResponse';
import type IBaseQueryResponse from 'store/types/IBaseQueryResponse';
import type { RootState } from '../../../types/TStore';
import type IAgentSessionBomExploreAiRequest from '../interfaces/IAgentSessionBomExploreAiRequest';
import type IAgentSessionBomItem from '../interfaces/IAgentSessionBomItem';
import type IAgentSessionBomLineItem from '../interfaces/IAgentSessionBomLineItem';
import type IAgentSessionBomSessionUnit from '../interfaces/IAgentSessionBomSessionUnit';
import type IAgentSessionSupplierDiscoveryItem from '../interfaces/IAgentSessionSupplierDiscoveryItem';
import type { IAIDraftConnection, IAIDraftUnit } from '../interfaces/IAIDraftUnitItem';
import type IAIDraftUnitItem from '../interfaces/IAIDraftUnitItem';
import type IAIDraftUnitsRequest from '../interfaces/IAIDraftUnitsRequest';
import type IApplyDraftSessionResponse from '../interfaces/IApplyDraftSessionResponse';
import type IArchiveValueChainItemRequest from '../interfaces/IArchiveValueChainItemRequest';
import type IBalanceSheetAssetsRequest from '../interfaces/IBalanceSheetAssetsRequest';
import type { IBoardFilter } from '../interfaces/IBoardFilter';
import type { IBoardInstanceGroup } from '../interfaces/IBoardInstanceGroup';
import type { IBoardUnit } from '../interfaces/IBoardUnit';
import type ICopyValueChainMapAnalysisScenariosRequest from '../interfaces/ICopyValueChainMapAnalysisScenariosRequest';
import type ICopyValueChainMapAnalysisScenariosResponse from '../interfaces/ICopyValueChainMapAnalysisScenariosResponse';
import type ICreateAgentSessionBomItemRequest from '../interfaces/ICreateAgentSessionBomItemRequest';
import type ICreateAgentSessionSupplierDiscoveryItemRequest from '../interfaces/ICreateAgentSessionSupplierDiscoveryItemRequest';
import type { ICreateBoardColumnRequest } from '../interfaces/ICreateBoardColumnRequest';
import type { ICreateLogicalConnection } from '../interfaces/ICreateLogicalConnection';
import type { ICreateManufactureConnection } from '../interfaces/ICreateManufactureConnection';
import type ICreateMonitoringScheduleRequest from '../interfaces/ICreateMonitoringScheduleRequest';
import type { ICreateServiceConnection } from '../interfaces/ICreateServiceConnection';
import type { ICreateSupplierConnection } from '../interfaces/ICreateSupplierConnection';
import type ICreateValueChainMapAnalysisRequest from '../interfaces/ICreateValueChainMapAnalysisRequest';
import type ICreateValueChainMapAnalysisScenarioRequest from '../interfaces/ICreateValueChainMapAnalysisScenarioRequest';
import type ICreateValueChainMapRequest from '../interfaces/ICreateValueChainMapRequest';
import type ICustomerRequest from '../interfaces/ICustomerRequest';
import type IDeleteAgentSessionBomItemRequest from '../interfaces/IDeleteAgentSessionBomItemRequest';
import type IDeleteAgentSessionSupplierDiscoveryItemRequest from '../interfaces/IDeleteAgentSessionSupplierDiscoveryItemRequest';
import type { IDeleteBoardColumnRequest } from '../interfaces/IDeleteBoardColumnRequest';
import type { IDeleteLogicalConnection } from '../interfaces/IDeleteLogicalConnection';
import type { IDeleteManufactureConnection } from '../interfaces/IDeleteManufactureConnection';
import type IDeleteMonitoringScheduleRequest from '../interfaces/IDeleteMonitoringScheduleRequest';
import type { IDeleteServiceConnection } from '../interfaces/IDeleteServiceConnection';
import type { IDeleteSupplierConnection } from '../interfaces/IDeleteSupplierConnection';
import type IDeleteValueChainItemRequest from '../interfaces/IDeleteValueChainItemrequest';
import type IDeleteValueChainMapAnalysisRequest from '../interfaces/IDeleteValueChainMapAnalysisRequest';
import type IDeleteValueChainMapAnalysisScenarioRequest from '../interfaces/IDeleteValueChainMapAnalysisScenarioRequest';
import type IDuplicateValueChainMapRequest from '../interfaces/IDuplicateValueChainMapRequest';
import type IEligibleAgentTemplate from '../interfaces/IEligibleAgentTemplate';
import type IExploreAgentSessionSupplierDiscoveryRequest from '../interfaces/IExploreAgentSessionSupplierDiscoveryRequest';
import type IGetAgentSessionBomByIdRequest from '../interfaces/IGetAgentSessionBomByIdRequest';
import type IGetAgentSessionBomItemsRequest from '../interfaces/IGetAgentSessionBomItemsRequest';
import type IGetAgentSessionBomRequest from '../interfaces/IGetAgentSessionBomRequest';
import type IGetAgentSessionSupplierDiscoveryItemsRequest from '../interfaces/IGetAgentSessionSupplierDiscoveryItemsRequest';
import type IGetBoardColumnNamesResponse from '../interfaces/IGetBoardColumnNamesResponse';
import type { IGetBoardUnitsRequest } from '../interfaces/IGetBoardUnitsRequest';
import type { IGetLogicalConnection } from '../interfaces/IGetLogicalConnection';
import type { IGetManufactureConnection } from '../interfaces/IGetManufactureConnection';
import type IGetMonitoringResultsRequest from '../interfaces/IGetMonitoringResultsRequest';
import type IGetMonitoringRunFindingsRequest from '../interfaces/IGetMonitoringRunFindingsRequest';
import type IGetMonitoringScheduleExecutionRequest from '../interfaces/IGetMonitoringScheduleExecutionRequest';
import type IGetMonitoringScheduleExecutionsRequest from '../interfaces/IGetMonitoringScheduleExecutionsRequest';
import type IGetMonitoringScheduleRunsRequest from '../interfaces/IGetMonitoringScheduleRunsRequest';
import type IGetMonitoringSchedulesRequest from '../interfaces/IGetMonitoringSchedulesRequest';
import type IGetMonitoringSessionExecutionRequest from '../interfaces/IGetMonitoringSessionExecutionRequest';
import type IGetMonitoringSessionExecutionsRequest from '../interfaces/IGetMonitoringSessionExecutionsRequest';
import type IGetOwnOperationResponse from '../interfaces/IGetOwnOperationResponse';
import type IGetProfitCentresResponse from '../interfaces/IGetProfitCentresResponse';
import type { IGetServiceConnection } from '../interfaces/IGetServiceConnection';
import type { IGetSupplierConnection } from '../interfaces/IGetSupplierConnection';
import type { IGetValueChainBoardResponse } from '../interfaces/IGetValueChainBoardResponse';
import type IGetValueChainMapAnalysesRequest from '../interfaces/IGetValueChainMapAnalysesRequest';
import type IGetValueChainMapAnalysisByIdRequest from '../interfaces/IGetValueChainMapAnalysisByIdRequest';
import type IGetValueChainMapAnalysisByIdResponse from '../interfaces/IGetValueChainMapAnalysisByIdResponse';
import type IGetValueChainMapAnalysisResultByIdRequest from '../interfaces/IGetValueChainMapAnalysisResultByIdRequest';
import type IGetValueChainMapAnalysisResultByIdResponse from '../interfaces/IGetValueChainMapAnalysisResultByIdResponse';
import type IGetValueChainMapAnalysisResultsRequest from '../interfaces/IGetValueChainMapAnalysisResultsRequest';
import type IGetValueChainMapAnalysisScenarioByIdRequest from '../interfaces/IGetValueChainMapAnalysisScenarioByIdRequest';
import type IGetValueChainMapAnalysisScenarioDownstreamResponse from '../interfaces/IGetValueChainMapAnalysisScenarioDownstreamResponse';
import type IGetValueChainMapAnalysisScenariosRequest from '../interfaces/IGetValueChainMapAnalysisScenariosRequest';
import type { IGetValueChainMapBusinessModelResponse } from '../interfaces/IGetValueChainMapBusinessModelResponse';
import type { IGetValueChainMapDetailsRequest } from '../interfaces/IGetValueChainMapDetailsRequest';
import type { IGetValueChainMapDetailsResponse } from '../interfaces/IGetValueChainMapDetailsResponse';
import type IImportAgentSessionBomXlsxRequest from '../interfaces/IImportAgentSessionBomXlsxRequest';
import type IImportAgentSessionSupplierDiscoveryXlsxRequest from '../interfaces/IImportAgentSessionSupplierDiscoveryXlsxRequest';
import type IImportAgentSessionSupplierDiscoveryXlsxResponse from '../interfaces/IImportAgentSessionSupplierDiscoveryXlsxResponse';
import type IOwnOperationsRequest from '../interfaces/IOwnOperationsRequest';
import type IPauseResumeMonitoringScheduleRequest from '../interfaces/IPauseResumeMonitoringScheduleRequest';
import type IProductRequest from '../interfaces/IProductRequest';
import type IProfitCenterRequest from '../interfaces/IProfitCenterRequest';
import type IRestoreValueChainItemRequest from '../interfaces/IRestoreValueChainItemRequest';
import type { IReviewValueChainItemRequest } from '../interfaces/IReviewValueChainItemRequest';
import type IRunMonitoringScheduleNowRequest from '../interfaces/IRunMonitoringScheduleNowRequest';
import type ISessionVCItem from '../interfaces/ISessionVCItem';
import type IStartValueChainMapAnalysisRequest from '../interfaces/IStartValueChainMapAnalysisRequest';
import type IStartValueChainMapAnalysisResponse from '../interfaces/IStartValueChainMapAnalysisResponse';
import type ISupplierRequest from '../interfaces/ISupplierRequest';
import type IUidNameTuplesVCRequest from '../interfaces/IUidNameTuplesVCRequest';
import type IUnitsDeleteRequest from '../interfaces/IUnitsDeleteRequest';
import type IUnitsSession from '../interfaces/IUnitsSession';
import type IUpdateAgentSessionBomItemRequest from '../interfaces/IUpdateAgentSessionBomItemRequest';
import type IUpdateAgentSessionBomRequest from '../interfaces/IUpdateAgentSessionBomRequest';
import type IUpdateAgentSessionBomSelectionRequest from '../interfaces/IUpdateAgentSessionBomSelectionRequest';
import type IUpdateAgentSessionSupplierDiscoveryItemRequest from '../interfaces/IUpdateAgentSessionSupplierDiscoveryItemRequest';
import type IUpdateAgentSessionSupplierDiscoveryRequest from '../interfaces/IUpdateAgentSessionSupplierDiscoveryRequest';
import type IUpdateAgentSessionSupplierDiscoverySelectionRequest from '../interfaces/IUpdateAgentSessionSupplierDiscoverySelectionRequest';
import type IUpdateAgentSessionUnitsRequest from '../interfaces/IUpdateAgentSessionUnitsRequest';
import type { IUpdateBoardColumnRequest } from '../interfaces/IUpdateBoardColumnRequest';
import type { IUpdateBoardUnitRequest } from '../interfaces/IUpdateBoardUnitRequest';
import type { IUpdateBusinessStructureOrgPathRequest } from '../interfaces/IUpdateBusinessStructureOrgPathRequest';
import type { IUpdateBusinessStructureStatusRequest } from '../interfaces/IUpdateBusinessStructureStatusRequest';
import type { IUpdateLogicalConnection } from '../interfaces/IUpdateLogicalConnection';
import type { IUpdateManufactureConnection } from '../interfaces/IUpdateManufactureConnection';
import type IUpdateMonitoringScheduleRequest from '../interfaces/IUpdateMonitoringScheduleRequest';
import type { IUpdateServiceConnection } from '../interfaces/IUpdateServiceConnection';
import type { IUpdateSupplierConnection } from '../interfaces/IUpdateSupplierConnection';
import type IUpdateValueChainItemRequest from '../interfaces/IUpdateValueChainItemRequest';
import type IUpdateValueChainMapAnalysisRequest from '../interfaces/IUpdateValueChainMapAnalysisRequest';
import type IUpdateValueChainMapAnalysisScenarioRequest from '../interfaces/IUpdateValueChainMapAnalysisScenarioRequest';
import type { IGetUserFiltersResponse, IUserFiltersPayload } from '../interfaces/IUserFilters';
import type { IValueChainBoardStructure } from '../interfaces/IValueChainBoardStructure';
import type IValueChainMap from '../interfaces/IValueChainMap';
import type IValueChainMapAnalysisItem from '../interfaces/IValueChainMapAnalysisItem';
import type IValueChainMapAnalysisResultItem from '../interfaces/IValueChainMapAnalysisResultItem';
import type IValueChainMapAnalysisScenario from '../interfaces/IValueChainMapAnalysisScenario';
import type IValueChainMapRequest from '../interfaces/IValueChainMapRequest';
import type IVCAgentSessionApplyRequest from '../interfaces/IVCAgentSessionApplyRequest';
import type IVCAgentSessionRequest from '../interfaces/IVCAgentSessionRequest';
import type IVCAgentSessionStartRequest from '../interfaces/IVCAgentSessionStartRequest';
import type IVCSupplierRequest from '../interfaces/IVCSupplierRequest';

const isDeletedDraftUnit = (
  draftUnit: IAIDraftUnit | null | undefined,
  draftUnitId: number,
): boolean => draftUnit?.id === draftUnitId;

const isDraftConnectionRelatedToUnit = (
  draftConnection: IAIDraftConnection,
  draftUnitId: number,
): boolean => (
  draftConnection.fromDraftId === draftUnitId
  || draftConnection.toDraftId === draftUnitId
  || Boolean(draftConnection.fromDraftUnit?.some((draftUnit) => isDeletedDraftUnit(draftUnit, draftUnitId)))
  || Boolean(draftConnection.toDraftUnit?.some((draftUnit) => isDeletedDraftUnit(draftUnit, draftUnitId)))
);

const getDraftStructureWithoutDraftUnit = (
  draftStructure: IAIDraftUnitItem,
  draftUnitId: number,
): IAIDraftUnitItem => ({
  ...draftStructure,
  draftUnits: draftStructure.draftUnits
    .filter((draftUnit) => draftUnit.id !== draftUnitId)
    .map((draftUnit) => ({
      ...draftUnit,
      draftConnectionToUnits: draftUnit.draftConnectionToUnits?.filter((draftConnection) => (
        !isDraftConnectionRelatedToUnit(draftConnection, draftUnitId)
      )),
    })),
  draftConnections: draftStructure.draftConnections.filter((draftConnection) => (
    !isDraftConnectionRelatedToUnit(draftConnection, draftUnitId)
  )),
});

export const valueChainMapApi = mainApi.injectEndpoints({
  endpoints: (builder) => ({
    getValueChainMapList: builder.query<IBaseQueryPaginationResponse<IValueChainMap[]>, IValueChainMapRequest>({
      query: ({
        search, ...rest
      }) => ({
        url: VALUE_CHAIN_MAP_LIST,
        method: HTTP_METHODS.GET,
        params: {
          keyword: search,
          ...rest,
        },
      }),
      merge: paginationMerge,
      serializeQueryArgs: paginationSerializeQueryArgs,
      forceRefetch: paginationForceRefetch,
      providesTags: [VALUE_CHAIN_MAP_LIST_TAG],
    }),
    updateValueChainItem: builder.mutation<
    IBaseQueryResponse<IValueChainMap>,
    IUpdateValueChainItemRequest
    >({
      query: ({ chainId, status, name }) => ({
        url: VALUE_CHAIN_MAP_UPDATE.replace('{chainId}', `${chainId}`),
        method: HTTP_METHODS.PATCH,
        body: {
          ...(name ? { name } : {}),
          ...(status ? { status } : {}),
        },
      }),
      onQueryStarted: async ({ chainId }, { getState, dispatch, queryFulfilled }) => {
        const { data: updatedData } = await queryFulfilled;
        updateValueChainMapList({
          valueChainMapApi,
          chainId,
          state: getState() as RootState,
          updatedData,
          dispatch,
        });
      },
      invalidatesTags: (result, error, { chainId }) => [
        { type: VALUE_CHAIN_MAP_DETAILS_TAG, id: chainId },
      ],
    }),
    deleteValueChainItem: builder.mutation<void, IDeleteValueChainItemRequest>({
      query: ({ chainId }) => ({
        url: VALUE_CHAIN_MAP_DELETE.replace('{chainId}', `${chainId}`),
        method: HTTP_METHODS.DELETE,
      }),
      onQueryStarted: async ({ chainId }, { getState, dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch {
          return;
        }

        deleteValueChainItemFromList({
          valueChainMapApi, chainId, state: getState() as RootState, dispatch,
        });
      },
    }),
    archiveValueChainItem: builder.mutation<
    IBaseQueryResponse<IValueChainMap>,
    IArchiveValueChainItemRequest
    >({
      query: ({ chainId, reason }) => ({
        url: VALUE_CHAIN_MAP_ARCHIVE.replace('{chainId}', `${chainId}`),
        method: HTTP_METHODS.PATCH,
        body: { reason },
      }),
      onQueryStarted: async ({ chainId }, { getState, dispatch, queryFulfilled }) => {
        const { data: updatedData } = await queryFulfilled;
        updateValueChainMapList({
          valueChainMapApi, chainId, state: getState() as RootState, updatedData, dispatch,
        });
      },
    }),
    reviewValueChainItem: builder.mutation<
    IBaseQueryResponse<IValueChainMap>,
    IReviewValueChainItemRequest
    >({
      query: ({ chainId, reason, status }) => ({
        url: VALUE_CHAIN_MAP_REVIEW.replace('{chainId}', `${chainId}`),
        method: HTTP_METHODS.PATCH,
        body: { reason, status },
      }),
      onQueryStarted: async ({ chainId }, {
        getState, dispatch, queryFulfilled,
      }) => {
        const { data: updatedData } = await queryFulfilled;

        updateValueChainMapList({
          valueChainMapApi, chainId, state: getState() as RootState, updatedData, dispatch,
        });
      },
    }),
    restoreValueChainItem: builder.mutation<
    IBaseQueryResponse<IValueChainMap>,
    IRestoreValueChainItemRequest
    >({
      query: ({ chainId }) => ({
        url: VALUE_CHAIN_MAP_DE_ARCHIVE.replace('{chainId}', `${chainId}`),
        method: HTTP_METHODS.PATCH,
      }),
      onQueryStarted: async ({ chainId }, { getState, dispatch, queryFulfilled }) => {
        const { data: updatedData } = await queryFulfilled;
        updateValueChainMapList({
          valueChainMapApi, chainId, state: getState() as RootState, updatedData, dispatch,
        });
      },
    }),
    getValueChainMapBusinessModel: builder.query<IGetValueChainMapBusinessModelResponse,
    { valueChainMapId: string }>({
      query: ({ valueChainMapId }) => ({
        url: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE.replace('{valueChainMapId}', `${valueChainMapId}`),
        method: HTTP_METHODS.GET,
      }),
      providesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
      ],
    }),
    getValueChainMapDetails: builder.query<IBaseQueryResponse<IGetValueChainMapDetailsResponse>,
    IGetValueChainMapDetailsRequest>({
      query: ({ chainId }) => ({
        url: VALUE_CHAIN_MAP_DETAILS.replace('{chainId}', `${chainId}`),
        method: HTTP_METHODS.GET,
      }),
      providesTags: (result, error, { chainId }) => [
        { type: VALUE_CHAIN_MAP_DETAILS_TAG, id: chainId },
      ],
    }),
    checkValueChainMapStatus: builder.query<IBaseQueryResponse<IGetValueChainMapDetailsResponse>,
    IGetValueChainMapDetailsRequest>({
      query: ({ chainId }) => ({
        url: VALUE_CHAIN_MAP_DETAILS.replace('{chainId}', `${chainId}`),
        method: HTTP_METHODS.GET,
      }),
      providesTags: [VALUE_CHAIN_MAP_LIST_TAG],
      onQueryStarted: async ({ chainId }, { getState, dispatch, queryFulfilled }) => {
        const { data: updatedData } = await queryFulfilled;
        dispatch(valueChainMapApi.util.updateQueryData(
          'getValueChainMapDetails',
          { chainId },
          (cache) => {
            const parseCache = cache;
            parseCache.data = updatedData.data;

            return parseCache;
          },
        ));
        upsertValueChainMapList({
          valueChainMapApi,
          chainId,
          state: getState() as RootState,
          updatedData,
          dispatch,
        });
      },
    }),
    createValueChainMap: builder.mutation<IBaseQueryResponse<IValueChainMap>,
    ICreateValueChainMapRequest>({
      query: ({ name }) => ({
        url: VALUE_CHAIN_MAP_CREATE,
        method: HTTP_METHODS.POST,
        body: { name },
      }),
    }),
    duplicateValueChainMap: builder.mutation<IBaseQueryResponse<IValueChainMap>,
    IDuplicateValueChainMapRequest>({
      query: ({ name, valueChainMapId }) => ({
        url: VALUE_CHAIN_MAP_DUPLICATE.replace('{chainId}', `${valueChainMapId}`),
        method: HTTP_METHODS.POST,
        body: { name },
      }),
    }),
    updateBusinessStructureStatus: builder.mutation<unknown, IUpdateBusinessStructureStatusRequest>({
      query: ({
        valueChainMapId, orgPath, disableReason, isDisabled,
      }) => ({
        url: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_STATUS,
        method: HTTP_METHODS.PATCH,
        body: {
          valueChainMapId,
          orgPath,
          disableReason,
          isDisabled,
        },
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
        VALUE_CHAIN_MAP_BOARD_TAG,
      ],
    }),
    updateBusinessStructureOrgPath: builder.mutation<unknown, IUpdateBusinessStructureOrgPathRequest>({
      query: ({
        valueChainMapId, targetParentOrgPath, childrenOrgPath,
      }) => ({
        url: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_ORG_PATH,
        method: HTTP_METHODS.PATCH,
        body: {
          valueChainMapId,
          targetParentOrgPath,
          childrenOrgPath,
        },
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
        VALUE_CHAIN_MAP_BOARD_TAG,
        { type: VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG, id: valueChainMapId },
      ],
    }),
    getProfitCentres: builder.query<IBaseQueryResponse<IGetProfitCentresResponse>,
    IGetValueChainMapDetailsRequest>({
      query: ({ chainId }) => ({
        url: VALUE_CHAIN_PROFIT_CENTER_DATA.replace('{profitCenterId}', ''),
        method: HTTP_METHODS.GET,
        params: {
          valueChainMapId: chainId,
          linkType: LINK_TYPES.unlinked,
          propertyType: PROPERTY_TYPES.businessUnitType,
          propertyValue: PROPERTY_VALUES.logical,
          orderBy: UNIQUE_IDENTIFIER,
        },
      }),
    }),
    getOwnOperations: builder.query<IBaseQueryResponse<IGetOwnOperationResponse>,
    IGetValueChainMapDetailsRequest>({
      query: ({ chainId }) => ({
        url: VALUE_CHAIN_OWN_OPERATION_DATA.replace('{recordId}', ''),
        method: HTTP_METHODS.GET,
        params: {
          valueChainMapId: chainId,
          propertyType: PROPERTY_TYPES.businessUnitType,
          propertyValue: PROPERTY_VALUES.logical,
        },
      }),
    }),
    getValueChainMapBoard: builder
      .query<IGetValueChainBoardResponse,
    { valueChainMapId: string, filters?: string, followConnections?: boolean }>({
      query: ({ valueChainMapId, filters = '', followConnections }) => {
        const queryParams = [filters, followConnections !== undefined ? `followConnections=${followConnections}` : '']
          .filter(Boolean);

        return {
          url: VALUE_CHAIN_MAP_BOARD.replace('{valueChainMapId}', valueChainMapId)
            + (queryParams.length ? `?${queryParams.join('&')}` : ''),
          method: HTTP_METHODS.GET,
          cache: 'no-store',
        };
      },
      providesTags: [VALUE_CHAIN_MAP_BOARD_TAG],
    }),
    updateBoardColumn: builder.mutation<unknown, IUpdateBoardColumnRequest>({
      query: ({ id, name, orderIndex }) => ({
        url: `${VALUE_CHAIN_MAP_BOARD_COLUMN}${id}`,
        method: HTTP_METHODS.PATCH,
        body: {
          name,
          orderIndex,
        },
      }),
      invalidatesTags: [
        VALUE_CHAIN_MAP_BOARD_TAG,
        VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG,
        VALUE_CHAIN_MAP_BOARD_COLUMN_NAMES_TAG,
      ],
    }),
    createBoardColumn: builder.mutation<unknown, ICreateBoardColumnRequest>({
      query: ({ valueChainMapId, boardId, name }) => ({
        url: VALUE_CHAIN_MAP_BOARD_COLUMN,
        method: HTTP_METHODS.POST,
        body: {
          valueChainMapId,
          boardId,
          name,
        },
      }),
      invalidatesTags: [
        VALUE_CHAIN_MAP_BOARD_TAG,
        VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG,
        VALUE_CHAIN_MAP_BOARD_COLUMN_NAMES_TAG,
      ],
    }),
    deleteBoardColumn: builder.mutation<unknown, IDeleteBoardColumnRequest>({
      query: ({ id }) => ({
        url: `${VALUE_CHAIN_MAP_BOARD_COLUMN}${id}`,
        method: HTTP_METHODS.DELETE,
      }),
      invalidatesTags: [
        VALUE_CHAIN_MAP_BOARD_TAG,
        VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG,
        VALUE_CHAIN_MAP_BOARD_COLUMN_NAMES_TAG,
      ],
    }),
    getProfitCenterData: builder.query<IBaseQueryResponse<IProfitCenterItem>,
    IGetValueChainMapDetailsRequest>({
      query: ({ chainId }) => ({
        url: VALUE_CHAIN_PROFIT_CENTER_DATA.replace('{profitCenterId}', `${chainId}`),
        method: HTTP_METHODS.GET,
      }),
    }),
    getOwnOperationData: builder.query<IBaseQueryResponse<IOwnItem>,
    IGetValueChainMapDetailsRequest>({
      query: ({ chainId }) => ({
        url: VALUE_CHAIN_OWN_OPERATION_DATA.replace('{recordId}', `${chainId}`),
        method: HTTP_METHODS.GET,
      }),
    }),
    createProfitCenter: builder.mutation <IBaseQueryResponse<IProfitCenterItem>,
    IProfitCenterRequest>({
      query: ({ data, valueChainMapId, columnId }) => ({
        url: VALUE_CHAIN_MAP_BOARD_UNIT_PROFIT_CENTER,
        method: HTTP_METHODS.POST,
        params: { valueChainMapId, columnId },
        body: data,
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG, id: valueChainMapId },
        VALUE_CHAIN_MAP_BOARD_TAG,
      ],
    }),
    updateProfitCenter: builder.mutation <IBaseQueryResponse<IProfitCenterItem>,
    IProfitCenterRequest>({
      query: ({ data, valueChainMapId, columnId }) => ({
        url: VALUE_CHAIN_PROFIT_CENTER_DATA.replace('{profitCenterId}', ''),
        method: HTTP_METHODS.PATCH,
        body: data,
        params: { valueChainMapId, columnId },
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG, id: valueChainMapId },
        VALUE_CHAIN_MAP_BOARD_TAG,
      ],
    }),
    createOwnOperation: builder.mutation <IBaseQueryResponse<IOwnItem>,
    IOwnOperationsRequest>({
      query: ({ valueChainMapId, data }) => ({
        url: VALUE_CHAIN_OWN_OPERATION_DATA.replace('{recordId}', ''),
        method: HTTP_METHODS.POST,
        params: { valueChainMapId },
        body: data,
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    updateOwnOperation: builder.mutation <IBaseQueryResponse<IOwnItem>,
    IOwnOperationsRequest>({
      query: ({ valueChainMapId, data }) => ({
        url: VALUE_CHAIN_OWN_OPERATION_DATA.replace('{recordId}', ''),
        method: HTTP_METHODS.PATCH,
        params: { valueChainMapId },
        body: data,
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    updateBoardUnit: builder.mutation<unknown, IUpdateBoardUnitRequest>({
      query: ({
        columnId, parentId, unitId, valueChainMapId, orderIndex,
      }) => ({
        url: VALUE_CHAIN_MAP_BOARD_UNIT.replace('{id}', `${unitId}`),
        method: HTTP_METHODS.PATCH,
        body: {
          columnId,
          parentId,
          valueChainMapId,
          orderIndex,
        },
      }),
      onQueryStarted: async ({
        unitId, columnId, parentId, orderIndex,
      }, { dispatch, getState, queryFulfilled }) => {
        const patches = valueChainMapApi.util
          .selectInvalidatedBy(getState() as RootState, [VALUE_CHAIN_MAP_BOARD_TAG])
          .filter(({ endpointName }) => endpointName === 'getValueChainMapBoard')
          .map(({ originalArgs }) => dispatch(valueChainMapApi.util.updateQueryData(
            'getValueChainMapBoard',
            originalArgs as { valueChainMapId: string, filters?: string },
            (cache) => ({
              ...cache,
              data: moveValueChainBoardUnit(cache.data, {
                unitId, columnId, parentId, orderIndex,
              }),
            }),
          )));

        try {
          await queryFulfilled;
        } catch {
          patches.forEach((patch) => patch.undo());
        }
      },
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    createLogicalConnection: builder.mutation<unknown, ICreateLogicalConnection>({
      query: ({
        valueChainMapId,
        fromUnitId,
        toUnitId,
        connectionType,
        comment,
        ownership,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_LOGICAL_CREATE,
        method: HTTP_METHODS.POST,
        body: {
          valueChainMapId,
          fromUnitId,
          toUnitId,
          connectionType,
          comment,
          ownership,
        },
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    getLogicalConnection: builder.query<unknown, IGetLogicalConnection>({
      query: ({
        id,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_LOGICAL.replace('{id}', `${id}`),
        method: HTTP_METHODS.GET,
      }),
    }),
    updateLogicalConnection: builder.mutation<unknown, IUpdateLogicalConnection>({
      query: ({
        id,
        toUnitId,
        connectionType,
        comment,
        ownership,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_LOGICAL.replace('{id}', `${id}`),
        method: HTTP_METHODS.PATCH,
        body: {
          toUnitId,
          connectionType,
          comment,
          ownership,
        },
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    deleteLogicalConnection: builder.mutation<unknown, IDeleteLogicalConnection>({
      query: ({
        id,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_LOGICAL.replace('{id}', `${id}`),
        method: HTTP_METHODS.DELETE,
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    createSupplierConnection: builder.mutation<unknown, ICreateSupplierConnection>({
      query: ({
        valueChainMapId,
        fromUnitId,
        toUnitId,
        transportMethods,
        distance,
        monetaryValue,
        monetaryCurrency,
        quantity,
        quantityUnit,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_SUPPLIER_CREATE,
        method: HTTP_METHODS.POST,
        body: {
          valueChainMapId,
          fromUnitId,
          toUnitId,
          transportMethods,
          distance,
          monetaryValue,
          monetaryCurrency,
          quantity,
          quantityUnit,
        },
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    getSupplierConnection: builder.query<unknown, IGetSupplierConnection>({
      query: ({
        id,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_SUPPLIER.replace('{id}', `${id}`),
        method: HTTP_METHODS.GET,
      }),
    }),
    updateSupplierConnection: builder.mutation<unknown, IUpdateSupplierConnection>({
      query: ({
        id,
        transportMethods,
        distance,
        monetaryValue,
        monetaryCurrency,
        quantity,
        quantityUnit,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_SUPPLIER.replace('{id}', `${id}`),
        method: HTTP_METHODS.PATCH,
        body: {
          transportMethods,
          distance,
          monetaryValue,
          monetaryCurrency,
          quantity,
          quantityUnit,
        },
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    deleteSupplierConnection: builder.mutation<unknown, IDeleteSupplierConnection>({
      query: ({
        id,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_SUPPLIER.replace('{id}', `${id}`),
        method: HTTP_METHODS.DELETE,
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    createServiceConnection: builder.mutation<unknown, ICreateServiceConnection>({
      query: ({
        valueChainMapId,
        fromUnitId,
        toUnitId,
        serviceProviderType,
        monetaryValue,
        monetaryCurrency,
        comment,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_SERVICE_CREATE,
        method: HTTP_METHODS.POST,
        body: {
          valueChainMapId,
          fromUnitId,
          toUnitId,
          serviceProviderType,
          monetaryValue,
          monetaryCurrency,
          comment,
        },
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    getServiceConnection: builder.query<unknown, IGetServiceConnection>({
      query: ({
        id,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_SERVICE.replace('{id}', `${id}`),
        method: HTTP_METHODS.GET,
      }),
    }),
    updateServiceConnection: builder.mutation<unknown, IUpdateServiceConnection>({
      query: ({
        id,
        toUnitId,
        serviceProviderType,
        monetaryValue,
        monetaryCurrency,
        comment,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_SERVICE.replace('{id}', `${id}`),
        method: HTTP_METHODS.PATCH,
        body: {
          toUnitId,
          serviceProviderType,
          monetaryValue,
          monetaryCurrency,
          comment,
        },
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    deleteServiceConnection: builder.mutation<unknown, IDeleteServiceConnection>({
      query: ({
        id,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_SERVICE.replace('{id}', `${id}`),
        method: HTTP_METHODS.DELETE,
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    createManufactureConnection: builder.mutation<unknown, ICreateManufactureConnection>({
      query: ({
        valueChainMapId,
        fromUnitId,
        toUnitId,
        connectionType,
        comment,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_MANUFACTURE_CREATE,
        method: HTTP_METHODS.POST,
        body: {
          valueChainMapId,
          fromUnitId,
          toUnitId,
          connectionType,
          comment,
        },
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    getManufactureConnection: builder.query<unknown, IGetManufactureConnection>({
      query: ({
        id,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_MANUFACTURE.replace('{id}', `${id}`),
        method: HTTP_METHODS.GET,
      }),
    }),
    updateManufactureConnection: builder.mutation<unknown, IUpdateManufactureConnection>({
      query: ({
        id,
        toUnitId,
        connectionType,
        comment,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_MANUFACTURE.replace('{id}', `${id}`),
        method: HTTP_METHODS.PATCH,
        body: {
          toUnitId,
          connectionType,
          comment,
        },
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    deleteManufactureConnection: builder.mutation<unknown, IDeleteManufactureConnection>({
      query: ({
        id,
      }) => ({
        url: VALUE_CHAIN_CONNECTION_MANUFACTURE.replace('{id}', `${id}`),
        method: HTTP_METHODS.DELETE,
      }),
      invalidatesTags: [VALUE_CHAIN_MAP_BOARD_TAG, VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG],
    }),
    getOrgStructureValueChainMap: builder.query<IGetOrgStructureResponse, { valueChainMapId: string }>({
      query: ({ valueChainMapId }) => ({
        url: VALUE_CHAIN_MAP_ORG_STRUCTURE.replace('{valueChainMapId}', `${valueChainMapId}`),
      }),
      providesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG, id: valueChainMapId },
      ],
    }),
    getBoardColumnNames: builder.query<IGetBoardColumnNamesResponse, { valueChainMapId: string }>({
      query: ({ valueChainMapId }) => ({
        url: VALUE_CHAIN_MAP_BOARD_COLUMN_NAMES.replace('{valueChainMapId}', `${valueChainMapId}`),
      }),
      providesTags: [VALUE_CHAIN_MAP_BOARD_COLUMN_NAMES_TAG],
    }),
    getVCSuppliers: builder.query<
    IBaseQueryPaginationResponse<ISupplierItem[]>, IVCSupplierRequest>({
      query: ({
        valueChainMapId, offset, keyword,
      }) => ({
        url: VALUE_CHAIN_MAP_BOARD_UNIT_SUPPLIER,
        params: {
          valueChainMapId,
          ...(offset ? { offset } : { offset: 0 }),
          ...(keyword ? { keyword } : {}),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: VC_SUPPLIER_LIST_TAG, id } as const)), VC_SUPPLIER_LIST_TAG]
          : [VC_SUPPLIER_LIST_TAG]
      ),
    }),
    getVCCustomers: builder.query<
    IBaseQueryPaginationResponse<ICustomerItem[]>, IVCSupplierRequest>({
      query: ({
        valueChainMapId, offset, keyword,
      }) => ({
        url: VALUE_CHAIN_MAP_BOARD_UNIT_CUSTOMER,
        params: {
          valueChainMapId,
          ...(offset ? { offset } : { offset: 0 }),
          ...(keyword ? { keyword } : {}),
          limit: DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result) => (
        result?.data?.items?.length && result?.data?.items?.length > 0
          ? [...result.data.items.map(({ id }) => (
            { type: VC_CUSTOMER_LIST_TAG, id } as const)), VC_CUSTOMER_LIST_TAG]
          : [VC_CUSTOMER_LIST_TAG]
      ),
    }),
    createCustomer: builder.mutation <IBaseQueryResponse<ICustomerItem>,
    ICustomerRequest>({
      query: ({ data, valueChainMapId, columnId }) => ({
        url: VALUE_CHAIN_MAP_BOARD_UNIT_CUSTOMER,
        method: HTTP_METHODS.POST,
        params: { valueChainMapId, columnId },
        body: data,
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG, id: valueChainMapId },
        VALUE_CHAIN_MAP_BOARD_TAG,
      ],
    }),
    updateCustomer: builder.mutation <IBaseQueryResponse<ICustomerItem>,
    ICustomerRequest>({
      query: ({ data, valueChainMapId, columnId }) => ({
        url: VALUE_CHAIN_CUSTOMER_DATA.replace('{customerId}', ''),
        method: HTTP_METHODS.PATCH,
        body: data,
        params: { valueChainMapId, columnId },
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG, id: valueChainMapId },
        VALUE_CHAIN_MAP_BOARD_TAG,
      ],
    }),
    getCustomerData: builder.query<IBaseQueryResponse<ICustomerItem>,
    IGetValueChainMapDetailsRequest>({
      query: ({ chainId }) => ({
        url: VALUE_CHAIN_CUSTOMER_DATA.replace('{customerId}', `${chainId}`),
        method: HTTP_METHODS.GET,
      }),
    }),
    getSupplierData: builder.query<IBaseQueryResponse<ISupplierItem>,
    IGetValueChainMapDetailsRequest>({
      query: ({ chainId }) => ({
        url: VALUE_CHAIN_SUPPLIER_DATA.replace('{supplierId}', `${chainId}`),
        method: HTTP_METHODS.GET,
      }),
    }),
    createSupplier: builder.mutation <IBaseQueryResponse<ISupplierItem>,
    ISupplierRequest>({
      query: ({ data, valueChainMapId, columnId }) => ({
        url: VALUE_CHAIN_MAP_BOARD_UNIT_SUPPLIER,
        method: HTTP_METHODS.POST,
        params: { valueChainMapId, columnId },
        body: data,
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG, id: valueChainMapId },
        VALUE_CHAIN_MAP_BOARD_TAG,
      ],
    }),
    updateSupplier: builder.mutation <IBaseQueryResponse<ISupplierItem>,
    ISupplierRequest>({
      query: ({ data, valueChainMapId, columnId }) => ({
        url: VALUE_CHAIN_SUPPLIER_DATA.replace('{supplierId}', ''),
        method: HTTP_METHODS.PATCH,
        body: data,
        params: { valueChainMapId, columnId },
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG, id: valueChainMapId },
        VALUE_CHAIN_MAP_BOARD_TAG,
      ],
    }),
    getProductData: builder.query<IBaseQueryResponse<IProductItem>,
    IGetValueChainMapDetailsRequest>({
      query: ({ chainId }) => ({
        url: VALUE_CHAIN_PRODUCT_DATA.replace('{productId}', `${chainId}`),
        method: HTTP_METHODS.GET,
      }),
    }),
    createProduct: builder.mutation <IBaseQueryResponse<IProductItem>,
    IProductRequest>({
      query: ({ data, valueChainMapId, columnId }) => ({
        url: VALUE_CHAIN_MAP_BOARD_UNIT_PRODUCT,
        method: HTTP_METHODS.POST,
        params: { valueChainMapId, columnId },
        body: data,
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG, id: valueChainMapId },
        VALUE_CHAIN_MAP_BOARD_TAG,
      ],
    }),
    updateProduct: builder.mutation <IBaseQueryResponse<IProductItem>,
    IProductRequest>({
      query: ({ data, valueChainMapId, columnId }) => ({
        url: VALUE_CHAIN_PRODUCT_DATA.replace('{productId}', ''),
        method: HTTP_METHODS.PATCH,
        body: data,
        params: { valueChainMapId, columnId },
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG, id: valueChainMapId },
        VALUE_CHAIN_MAP_BOARD_TAG,
      ],
    }),
    getBalanceSheetAssetsData: builder.query<IBaseQueryResponse<IOwnItem>,
    IGetValueChainMapDetailsRequest>({
      query: ({ chainId }) => ({
        url: VALUE_CHAIN_OWN_OPERATION_DATA.replace('{recordId}', `${chainId}`),
        method: HTTP_METHODS.GET,
      }),
    }),
    createBalanceSheetAssets: builder.mutation <IBaseQueryResponse<IOwnItem>,
    IBalanceSheetAssetsRequest>({
      query: ({ data, valueChainMapId, columnId }) => ({
        url: VALUE_BALANCE_SHEET_ASSET,
        method: HTTP_METHODS.POST,
        params: { valueChainMapId, columnId },
        body: data,
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG, id: valueChainMapId },
        VALUE_CHAIN_MAP_BOARD_TAG,
      ],
    }),
    updateBalanceSheetAssets: builder.mutation <IBaseQueryResponse<IOwnItem>,
    IBalanceSheetAssetsRequest>({
      query: ({ data, valueChainMapId, columnId }) => ({
        url: VALUE_CHAIN_OWN_OPERATION_DATA.replace('{recordId}', ''),
        method: HTTP_METHODS.PATCH,
        body: data,
        params: { valueChainMapId, columnId },
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_BUSINESS_STRUCTURE_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ORG_STRUCTURE_TAG, id: valueChainMapId },
        VALUE_CHAIN_MAP_BOARD_TAG,
      ],
    }),
    uidNameTuplesVC: builder.query<IUidNameTuplesResponse, IUidNameTuplesVCRequest>({
      // Record-refs endpoint serves one record type per request, so fan out over the
      // requested types and re-assemble the type-grouped shape the selectors expect.
      async queryFn({ types, valueChainMapId }, _api, _extraOptions, baseQuery) {
        const results = await Promise.all(types.map((type) => baseQuery({
          url: VALUE_CHAIN_MAP_RECORD_REFS.replace('{valueChainMapId}', `${valueChainMapId}`),
          params: { type },
        })));

        const failed = results.find((result) => result.error);
        if (failed?.error) {
          return { error: failed.error };
        }

        const data = types.map((type, index) => {
          const refs = (results[index].data as IRecordRefsResponse).data;
          return {
            name: type,
            enum: Object.entries(refs).map(([value, { label, profitCentreUIDs }]) => (
              { value, label, profitCentreUIDs }
            )),
          };
        });

        return { data: { data } };
      },
    }),
    // Serves the record-refs payload as the backend returns it, scoped to a value chain map.
    recordRefsVC: builder.query<IRecordRefsResponse, IRecordRefsVCRequest>({
      query: ({ type, valueChainMapId, profitCentreUID }) => ({
        url: VALUE_CHAIN_MAP_RECORD_REFS.replace('{valueChainMapId}', `${valueChainMapId}`),
        params: { type, ...(profitCentreUID ? { profitCentreUID } : {}) },
      }),
    }),
    getVCAgentSessions: builder.query<
    IBaseQueryResponse<ISessionVCItem[]>, IVCAgentSessionRequest>({
      query: ({
        valueChainMapId,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSIONS.replace('{valueChainMapId}', `${valueChainMapId}`),
      }),
      providesTags: (result) => (
        result?.data?.length && result?.data?.length > 0
          ? [...result.data.map(({ id }) => (
            { type: VC_AGENT_SESSION_LIST_TAG, id } as const)), VC_AGENT_SESSION_LIST_TAG]
          : [VC_AGENT_SESSION_LIST_TAG]
      ),
    }),
    createVCAgentSession: builder.mutation <IBaseQueryResponse<ISessionVCItem>,
    IVCAgentSessionRequest>({
      query: ({ data, valueChainMapId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSIONS.replace('{valueChainMapId}', `${valueChainMapId}`),
        method: HTTP_METHODS.POST,
        body: data,
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    getVCAgentSessionsId: builder.query<
    IBaseQueryResponse<ISessionVCItem>, IVCAgentSessionRequest>({
      query: ({
        valueChainMapId,
        sessionId,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION.replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
      }),
      providesTags: (result, error, { valueChainMapId, sessionId }) => (
        [{ type: VC_AGENT_SESSION_RECORD_TAG, id: `${valueChainMapId}-${sessionId}` }]
      ),
    }),
    addedVCAgentSessionUnits: builder.mutation <null,
    IUnitsSession>({
      query: ({ itemsId, valueChainMapId, sessionId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_UNITS.replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
        method: HTTP_METHODS.PATCH,
        body: { unitIds: itemsId },
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId }) => [
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        { type: VC_AGENT_SESSION_RECORD_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    startVCAgentSession: builder.mutation <IBaseQueryResponse<ISessionVCItem>,
    IVCAgentSessionStartRequest>({
      query: ({ data, valueChainMapId, sessionId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_START.replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
        method: HTTP_METHODS.POST,
        body: data,
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId }) => [
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        { type: VC_AGENT_SESSION_RECORD_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_LIST_TAG,
        {
          type: VC_AGENT_MONITORING_SESSION_EXECUTIONS_TAG,
          id: `${valueChainMapId}-${sessionId}`,
        },
        VC_AGENT_MONITORING_SESSION_EXECUTIONS_TAG,
      ],
    }),
    getAIDraftUnits: builder.query<
    IBaseQueryResponse<IAIDraftUnitItem>, IAIDraftUnitsRequest>({
      query: ({
        sessionId, valueChainMapId,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_DRAFT_COLUMN_STRUCTURE
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
      }),
      providesTags: (result, error, { valueChainMapId, sessionId }) => (
        [{ type: VC_DRAFT_STRUCTURE_TAG, id: `${valueChainMapId}-${sessionId}` }]
      ),
    }),
    deleteDraftSessionUnits: builder.mutation <null,
    IUnitsDeleteRequest>({
      query: ({ id, sessionId, valueChainMapId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_DRAFT_UNIT
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.DELETE,
      }),
      onQueryStarted: async ({
        id, sessionId, valueChainMapId,
      }, { dispatch, queryFulfilled }) => {
        try {
          await queryFulfilled;
        } catch {
          return;
        }

        dispatch(valueChainMapApi.util.updateQueryData(
          'getAIDraftUnits',
          { sessionId, valueChainMapId },
          (draftUnits) => ({
            ...draftUnits,
            data: getDraftStructureWithoutDraftUnit(draftUnits.data, id),
          }),
        ));
      },
      invalidatesTags: (result, error, { valueChainMapId, sessionId }) => [
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        { type: VC_AGENT_SESSION_RECORD_TAG, id: `${valueChainMapId}-${sessionId}` },
        { type: VC_DRAFT_STRUCTURE_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    applyDraftSession: builder.mutation <IApplyDraftSessionResponse,
    IVCAgentSessionApplyRequest>({
      query: ({ sessionId, valueChainMapId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_APPLY
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
        method: HTTP_METHODS.POST,
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        VC_AGENT_SESSION_LIST_TAG,
        VALUE_CHAIN_MAP_BOARD_TAG,
      ],
    }),
    startAgentSessionReview: builder.mutation<void, IVCAgentSessionApplyRequest>({
      query: ({ sessionId, valueChainMapId }) => ({
        url: '/value-chain-maps/{valueChainMapId}/agent-sessions/{sessionId}/start-review'
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
        method: HTTP_METHODS.POST,
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId }) => [
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        { type: VC_AGENT_SESSION_RECORD_TAG, id: `${valueChainMapId}-${sessionId}` },
        { type: VC_DRAFT_STRUCTURE_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    cancelAgentSessionReview: builder.mutation<void, IVCAgentSessionApplyRequest>({
      query: ({ sessionId, valueChainMapId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_CANCEL_REVIEW
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
        method: HTTP_METHODS.POST,
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId }) => [
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        { type: VC_AGENT_SESSION_RECORD_TAG, id: `${valueChainMapId}-${sessionId}` },
        { type: VC_DRAFT_STRUCTURE_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    deleteSession: builder.mutation <null,
    { valueChainMapId: string, sessionId: number }>({
      query: ({ valueChainMapId, sessionId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION.replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
        method: HTTP_METHODS.DELETE,
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    getAgentSessionBom: builder.query<
    IBaseQueryResponse<IAgentSessionBomItem[]>,
    IGetAgentSessionBomRequest
    >({
      query: ({ valueChainMapId, sessionId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_BOM
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
      }),
      providesTags: (result, error, { valueChainMapId, sessionId }) => [
        { type: VC_AGENT_SESSION_BOM_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_BOM_TAG,
      ],
    }),
    getAgentSessionBomById: builder.query<
    IBaseQueryResponse<IAgentSessionBomItem>,
    IGetAgentSessionBomByIdRequest
    >({
      query: ({ valueChainMapId, sessionId, bomId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_BOM_ITEM
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{bomId}', `${bomId}`),
      }),
      providesTags: (result, error, { valueChainMapId, sessionId, bomId }) => [
        { type: VC_AGENT_SESSION_BOM_RECORD_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}` },
        VC_AGENT_SESSION_BOM_RECORD_TAG,
        { type: VC_AGENT_SESSION_BOM_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_BOM_TAG,
      ],
    }),
    getAgentSessionBomXlsxExample: builder.query<void, IGetAgentSessionBomByIdRequest>({
      query: ({ valueChainMapId, sessionId, bomId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_BOM_XLSX_EXAMPLE
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{bomId}', `${bomId}`),
        responseHandler: async (response) => downloadFileHandler({
          filename: SHEET_EXAMPLE_FILES_NAME.bom,
          response,
        }),
        cache: 'no-cache',
      }),
    }),
    importAgentSessionBomXlsx: builder.mutation<void, IImportAgentSessionBomXlsxRequest>({
      query: ({
        valueChainMapId, sessionId, bomId, url,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_BOM_IMPORT_XLSX
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{bomId}', `${bomId}`),
        method: HTTP_METHODS.POST,
        body: { url },
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId, bomId }) => [
        { type: VC_AGENT_SESSION_BOM_RECORD_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}` },
        VC_AGENT_SESSION_BOM_RECORD_TAG,
        { type: VC_AGENT_SESSION_BOM_ITEMS_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}` },
        VC_AGENT_SESSION_BOM_ITEMS_TAG,
        { type: VC_AGENT_SESSION_BOM_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_BOM_TAG,
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    getAgentSessionBomItems: builder.query<
    IBaseQueryPaginationResponse<IAgentSessionBomLineItem[]>,
    IGetAgentSessionBomItemsRequest
    >({
      query: ({
        valueChainMapId, sessionId, bomId, offset, limit, orderBy,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_BOM_ITEMS
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{bomId}', `${bomId}`),
        params: {
          ...(offset ? { offset } : { offset: 0 }),
          ...(orderBy ? { orderBy } : { orderBy: [TASK_SORT_BY.LAST_MODIFIED] }),
          limit: limit ?? DATA_SET_PAGINATION_COUNT,
        },
      }),
      providesTags: (result, error, { valueChainMapId, sessionId, bomId }) => [
        { type: VC_AGENT_SESSION_BOM_ITEMS_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}` },
        VC_AGENT_SESSION_BOM_ITEMS_TAG,
      ],
    }),
    updateAgentSessionBom: builder.mutation<
    IBaseQueryResponse<IAgentSessionBomItem>,
    IUpdateAgentSessionBomRequest
    >({
      query: ({
        valueChainMapId, sessionId, bomId, body,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_BOM_ITEM
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{bomId}', `${bomId}`),
        method: HTTP_METHODS.PATCH,
        body,
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId, bomId }) => [
        { type: VC_AGENT_SESSION_BOM_RECORD_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}` },
        VC_AGENT_SESSION_BOM_RECORD_TAG,
        { type: VC_AGENT_SESSION_BOM_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_BOM_TAG,
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    updateAgentSessionBomSelection: builder.mutation<void, IUpdateAgentSessionBomSelectionRequest>({
      query: ({
        valueChainMapId, sessionId, bomId, body,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_BOM_SELECTION
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{bomId}', `${bomId}`),
        method: HTTP_METHODS.PATCH,
        body,
      }),
      onQueryStarted: async ({
        valueChainMapId, sessionId, bomId, body,
      }, {
        getState, dispatch, queryFulfilled,
      }) => {
        try {
          await queryFulfilled;
        } catch {
          return;
        }

        syncBomSelectionInCaches({
          valueChainMapApi,
          state: getState() as RootState,
          dispatch,
          valueChainMapId,
          sessionId,
          bomId,
          isActive: body.isActive,
        });
      },
      invalidatesTags: (result, error, { valueChainMapId, sessionId, bomId }) => [
        { type: VC_AGENT_SESSION_BOM_RECORD_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}` },
        VC_AGENT_SESSION_BOM_RECORD_TAG,
        { type: VC_AGENT_SESSION_BOM_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_BOM_TAG,
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    createAgentSessionBomItem: builder.mutation<
    IBaseQueryResponse<IAgentSessionBomLineItem>,
    ICreateAgentSessionBomItemRequest
    >({
      query: ({ valueChainMapId, sessionId, bomId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_BOM_ITEMS
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{bomId}', `${bomId}`),
        method: HTTP_METHODS.POST,
      }),
      onQueryStarted: async ({ valueChainMapId, sessionId, bomId }, {
        getState, dispatch, queryFulfilled,
      }) => {
        try {
          const { data: createdResponse } = await queryFulfilled;

          syncCreatedBomItemInCaches({
            valueChainMapApi,
            state: getState() as RootState,
            dispatch,
            valueChainMapId,
            sessionId,
            bomId,
            item: createdResponse.data,
          });
        } catch {
          // noop
        }
      },
      invalidatesTags: (result, error, { valueChainMapId, sessionId, bomId }) => [
        { type: VC_AGENT_SESSION_BOM_RECORD_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}` },
        VC_AGENT_SESSION_BOM_RECORD_TAG,
        { type: VC_AGENT_SESSION_BOM_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_BOM_TAG,
      ],
    }),
    updateAgentSessionBomItem: builder.mutation<
    IBaseQueryResponse<IAgentSessionBomLineItem>,
    IUpdateAgentSessionBomItemRequest
    >({
      query: ({
        valueChainMapId, sessionId, bomId, itemId, body,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_BOM_LINE_ITEM
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{bomId}', `${bomId}`)
          .replace('{itemId}', `${itemId}`),
        method: HTTP_METHODS.PATCH,
        body,
      }),
      onQueryStarted: async ({
        valueChainMapId, sessionId, bomId,
      }, {
        getState, dispatch, queryFulfilled,
      }) => {
        try {
          const { data: updatedResponse } = await queryFulfilled;

          syncUpdatedBomItemInCaches({
            valueChainMapApi,
            state: getState() as RootState,
            dispatch,
            valueChainMapId,
            sessionId,
            bomId,
            item: updatedResponse.data,
          });
        } catch {
          // noop
        }
      },
      invalidatesTags: (result, error, {
        valueChainMapId, sessionId, bomId, itemId,
      }) => [
        { type: VC_AGENT_SESSION_BOM_LINE_ITEM_RECORD_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}-${itemId}` },
        VC_AGENT_SESSION_BOM_LINE_ITEM_RECORD_TAG,
        { type: VC_AGENT_SESSION_BOM_RECORD_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}` },
        VC_AGENT_SESSION_BOM_RECORD_TAG,
        { type: VC_AGENT_SESSION_BOM_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_BOM_TAG,
      ],
    }),
    deleteAgentSessionBomItem: builder.mutation<void, IDeleteAgentSessionBomItemRequest>({
      query: ({
        valueChainMapId, sessionId, bomId, itemId,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_BOM_LINE_ITEM
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{bomId}', `${bomId}`)
          .replace('{itemId}', `${itemId}`),
        method: HTTP_METHODS.DELETE,
      }),
      onQueryStarted: async ({
        valueChainMapId, sessionId, bomId, itemId,
      }, {
        getState, dispatch, queryFulfilled,
      }) => {
        try {
          await queryFulfilled;
        } catch {
          return;
        }

        syncDeletedBomItemInCaches({
          valueChainMapApi,
          state: getState() as RootState,
          dispatch,
          valueChainMapId,
          sessionId,
          bomId,
          itemId,
        });
      },
      invalidatesTags: (result, error, {
        valueChainMapId, sessionId, bomId, itemId,
      }) => [
        { type: VC_AGENT_SESSION_BOM_LINE_ITEM_RECORD_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}-${itemId}` },
        VC_AGENT_SESSION_BOM_LINE_ITEM_RECORD_TAG,
        { type: VC_AGENT_SESSION_BOM_RECORD_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}` },
        VC_AGENT_SESSION_BOM_RECORD_TAG,
        { type: VC_AGENT_SESSION_BOM_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_BOM_TAG,
      ],
    }),
    exploreAgentSessionBomAi: builder.mutation<void, IAgentSessionBomExploreAiRequest>({
      query: ({
        valueChainMapId, sessionId, bomId,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_BOM_EXPLORE_AI
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{bomId}', `${bomId}`),
        method: HTTP_METHODS.POST,
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId, bomId }) => [
        { type: VC_AGENT_SESSION_BOM_RECORD_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}` },
        VC_AGENT_SESSION_BOM_RECORD_TAG,
        { type: VC_AGENT_SESSION_BOM_ITEMS_TAG, id: `${valueChainMapId}-${sessionId}-${bomId}` },
        VC_AGENT_SESSION_BOM_ITEMS_TAG,
        { type: VC_AGENT_SESSION_BOM_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_BOM_TAG,
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    getValueChainMapAnalyses: builder.query<
    IBaseQueryPaginationResponse<IValueChainMapAnalysisItem[]>,
    IGetValueChainMapAnalysesRequest
    >({
      query: ({
        valueChainMapId, offset, limit, orderBy,
      }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS.replace('{valueChainMapId}', `${valueChainMapId}`),
        method: HTTP_METHODS.GET,
        params: {
          offset: offset ?? 0,
          limit: limit ?? DATA_SET_PAGINATION_COUNT,
          ...(orderBy ? { orderBy } : {}),
        },
      }),
      providesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: valueChainMapId },
      ],
    }),
    createValueChainMapAnalysis: builder.mutation<
    IBaseQueryResponse<IValueChainMapAnalysisItem>,
    ICreateValueChainMapAnalysisRequest
    >({
      query: ({ valueChainMapId, name }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS.replace('{valueChainMapId}', `${valueChainMapId}`),
        method: HTTP_METHODS.POST,
        body: { name },
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: valueChainMapId },
      ],
    }),
    deleteValueChainMapAnalysis: builder.mutation<void, IDeleteValueChainMapAnalysisRequest>({
      query: ({ valueChainMapId, id }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_BY_ID
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.DELETE,
      }),
      invalidatesTags: (result, error, { valueChainMapId, id }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${id}` },
      ],
    }),
    getValueChainMapAnalysisById: builder.query<
    IBaseQueryResponse<IGetValueChainMapAnalysisByIdResponse>,
    IGetValueChainMapAnalysisByIdRequest
    >({
      query: ({ valueChainMapId, id }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_BY_ID
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.GET,
      }),
      providesTags: (result, error, { valueChainMapId, id }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${id}` },
      ],
    }),
    getValueChainMapAnalysisScenarioById: builder.query<
    IBaseQueryResponse<IValueChainMapAnalysisScenario>,
    IGetValueChainMapAnalysisScenarioByIdRequest
    >({
      query: ({ valueChainMapId, analysisId, id }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_SCENARIO_BY_ID
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{analysisId}', `${analysisId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.GET,
      }),
    }),
    createValueChainMapAnalysisScenario: builder.mutation<
    IBaseQueryResponse<IValueChainMapAnalysisScenario>,
    ICreateValueChainMapAnalysisScenarioRequest
    >({
      query: ({
        valueChainMapId,
        analysisId,
        name,
        affectedPeriod,
        affectedPeriodUnit,
        productivityImpact,
        unitIds,
      }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_SCENARIO_CREATE
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{analysisId}', `${analysisId}`),
        method: HTTP_METHODS.POST,
        body: {
          name,
          affectedPeriod,
          affectedPeriodUnit,
          productivityImpact,
          unitIds,
        },
      }),
      invalidatesTags: (result, error, { valueChainMapId, analysisId }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${analysisId}` },
      ],
    }),
    deleteValueChainMapAnalysisScenario: builder.mutation<
    void,
    IDeleteValueChainMapAnalysisScenarioRequest
    >({
      query: ({ valueChainMapId, analysisId, id }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_SCENARIO_BY_ID
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{analysisId}', `${analysisId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.DELETE,
      }),
      invalidatesTags: (result, error, { valueChainMapId, analysisId, id }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${analysisId}` },
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${analysisId}-scenario-${id}-downstream` },
      ],
    }),
    updateValueChainMapAnalysisScenario: builder.mutation<
    IBaseQueryResponse<IValueChainMapAnalysisScenario>,
    IUpdateValueChainMapAnalysisScenarioRequest
    >({
      query: ({
        valueChainMapId,
        analysisId,
        id,
        name,
        affectedPeriod,
        affectedPeriodUnit,
        productivityImpact,
        unitIds,
      }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_SCENARIO_BY_ID
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{analysisId}', `${analysisId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.PATCH,
        body: {
          name,
          affectedPeriod,
          affectedPeriodUnit,
          productivityImpact,
          unitIds,
        },
      }),
      invalidatesTags: (result, error, { valueChainMapId, analysisId, id }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${analysisId}` },
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${analysisId}-scenario-${id}-downstream` },
      ],
    }),
    updateValueChainMapAnalysis: builder.mutation<
    IBaseQueryResponse<IValueChainMapAnalysisItem>,
    IUpdateValueChainMapAnalysisRequest
    >({
      query: ({ valueChainMapId, id, name }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_BY_ID
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.PATCH,
        body: { name },
      }),
      invalidatesTags: (result, error, { valueChainMapId, id }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${id}` },
      ],
    }),
    startValueChainMapAnalysis: builder.mutation<
    IBaseQueryResponse<IStartValueChainMapAnalysisResponse> | undefined,
    IStartValueChainMapAnalysisRequest
    >({
      query: ({ valueChainMapId, id }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_START
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.POST,
      }),
      invalidatesTags: (result, error, { valueChainMapId, id }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${id}` },
      ],
    }),
    getValueChainMapAnalysisScenarioDownstream: builder.query<
    IBaseQueryResponse<IGetValueChainMapAnalysisScenarioDownstreamResponse>,
    IGetValueChainMapAnalysisScenarioByIdRequest
    >({
      query: ({ valueChainMapId, analysisId, id }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_SCENARIO_DOWNSTREAM
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{analysisId}', `${analysisId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.GET,
      }),
      providesTags: (result, error, { valueChainMapId, analysisId, id }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${analysisId}-scenario-${id}-downstream` },
      ],
    }),
    getValueChainMapAnalysisResults: builder.query<
    IBaseQueryPaginationResponse<IValueChainMapAnalysisResultItem[]>,
    IGetValueChainMapAnalysisResultsRequest
    >({
      query: ({
        valueChainMapId, analysisId, offset, limit, orderBy,
      }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_RESULTS
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{analysisId}', `${analysisId}`),
        method: HTTP_METHODS.GET,
        params: {
          offset: offset ?? 0,
          limit: limit ?? DATA_SET_PAGINATION_COUNT,
          ...(orderBy ? { orderBy } : {}),
        },
      }),
      providesTags: (result, error, { valueChainMapId, analysisId }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${analysisId}` },
      ],
    }),
    getValueChainMapAnalysisResultById: builder.query<
    IBaseQueryResponse<IGetValueChainMapAnalysisResultByIdResponse>,
    IGetValueChainMapAnalysisResultByIdRequest
    >({
      query: ({ valueChainMapId, analysisId, id }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_RESULT_BY_ID
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{analysisId}', `${analysisId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.GET,
      }),
      providesTags: (result, error, { valueChainMapId, analysisId, id }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${analysisId}-result-${id}` },
      ],
    }),
    getValueChainMapAnalysisResultDownstream: builder.query<
    IBaseQueryResponse<IGetValueChainMapAnalysisScenarioDownstreamResponse>,
    IGetValueChainMapAnalysisResultByIdRequest
    >({
      query: ({ valueChainMapId, analysisId, id }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_RESULT_DOWNSTREAM
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{analysisId}', `${analysisId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.GET,
      }),
    }),
    copyValueChainMapAnalysisResult: builder.mutation<
    IBaseQueryResponse<IValueChainMapAnalysisScenario>,
    IGetValueChainMapAnalysisResultByIdRequest
    >({
      query: ({ valueChainMapId, analysisId, id }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_RESULT_COPY
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{analysisId}', `${analysisId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.POST,
      }),
      invalidatesTags: (result, error, { valueChainMapId, analysisId }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${analysisId}` },
      ],
    }),
    deleteValueChainMapAnalysisResultById: builder.mutation<void, IGetValueChainMapAnalysisResultByIdRequest>({
      query: ({ valueChainMapId, analysisId, id }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_RESULT_BY_ID
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{analysisId}', `${analysisId}`)
          .replace('{id}', `${id}`),
        method: HTTP_METHODS.DELETE,
      }),
      invalidatesTags: (result, error, { valueChainMapId, analysisId, id }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${analysisId}` },
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${analysisId}-result-${id}` },
      ],
    }),
    getValueChainMapAnalysisScenarios: builder.query<
    IBaseQueryPaginationResponse<IValueChainMapAnalysisScenario[]>,
    IGetValueChainMapAnalysisScenariosRequest
    >({
      query: ({
        valueChainMapId, offset, limit, orderBy,
      }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_SCENARIO
          .replace('{valueChainMapId}', `${valueChainMapId}`),
        method: HTTP_METHODS.GET,
        params: {
          offset: offset ?? 0,
          limit: limit ?? DATA_SET_PAGINATION_COUNT,
          ...(orderBy ? { orderBy } : {}),
        },
      }),
      providesTags: (result, error, { valueChainMapId }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}` },
      ],
    }),
    copyValueChainMapAnalysisScenarios: builder.mutation<
    IBaseQueryResponse<ICopyValueChainMapAnalysisScenariosResponse[]>,
    ICopyValueChainMapAnalysisScenariosRequest
    >({
      query: ({ valueChainMapId, analysisId, scenarioIds }) => ({
        url: VALUE_CHAIN_MAP_ANALYSIS_SCENARIO_COPY
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{analysisId}', `${analysisId}`),
        method: HTTP_METHODS.POST,
        body: { scenarioIds },
      }),
      invalidatesTags: (result, error, { valueChainMapId, analysisId }) => [
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: valueChainMapId },
        { type: VALUE_CHAIN_MAP_ANALYSES_TAG, id: `${valueChainMapId}-${analysisId}` },
      ],
    }),
    getAgentSessionSupplierDiscovery: builder.query<
    IBaseQueryResponse<IAgentSessionBomSessionUnit[]>,
    IVCAgentSessionApplyRequest
    >({
      query: ({ valueChainMapId, sessionId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
        method: HTTP_METHODS.GET,
      }),
      providesTags: (result, error, { valueChainMapId, sessionId }) => [
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG,
      ],
    }),
    updateAgentSessionSupplierDiscovery: builder.mutation<
    IAgentSessionBomSessionUnit,
    IUpdateAgentSessionSupplierDiscoveryRequest
    >({
      query: ({
        valueChainMapId, sessionId, unitId, status,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{unitId}', `${unitId}`),
        method: HTTP_METHODS.PATCH,
        body: { status },
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId, unitId }) => [
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG, id: `${valueChainMapId}-${sessionId}-${unitId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG,
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG,
      ],
    }),
    getAgentSessionSupplierDiscoveryItems: builder.query<
    IBaseQueryPaginationResponse<IAgentSessionSupplierDiscoveryItem[]>,
    IGetAgentSessionSupplierDiscoveryItemsRequest
    >({
      query: ({
        valueChainMapId, sessionId, unitId, offset, limit, orderBy,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_ITEMS
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{unitId}', `${unitId}`),
        method: HTTP_METHODS.GET,
        params: {
          offset: offset ?? 0,
          limit: limit ?? DATA_SET_PAGINATION_COUNT,
          ...(orderBy ? { orderBy } : {}),
        },
      }),
      providesTags: (result, error, { valueChainMapId, sessionId, unitId }) => [
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEMS_TAG, id: `${valueChainMapId}-${sessionId}-${unitId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEMS_TAG,
      ],
    }),
    createAgentSessionSupplierDiscoveryItem: builder.mutation<
    IBaseQueryResponse<IAgentSessionSupplierDiscoveryItem>,
    ICreateAgentSessionSupplierDiscoveryItemRequest
    >({
      query: ({
        valueChainMapId, sessionId, unitId,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_ITEMS
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{unitId}', `${unitId}`),
        method: HTTP_METHODS.POST,
      }),
      onQueryStarted: async ({ valueChainMapId, sessionId, unitId }, {
        getState, dispatch, queryFulfilled,
      }) => {
        try {
          const { data: createdResponse } = await queryFulfilled;

          syncCreatedSupplierDiscoveryItemInCaches({
            valueChainMapApi,
            state: getState() as RootState,
            dispatch,
            valueChainMapId,
            sessionId,
            unitId,
            item: createdResponse.data,
          });
        } catch {
          // noop
        }
      },
      invalidatesTags: (result, error, { valueChainMapId, sessionId, unitId }) => [
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG, id: `${valueChainMapId}-${sessionId}-${unitId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG,
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG,
      ],
    }),
    updateAgentSessionSupplierDiscoveryItem: builder.mutation<
    IBaseQueryResponse<IAgentSessionSupplierDiscoveryItem>,
    IUpdateAgentSessionSupplierDiscoveryItemRequest
    >({
      query: ({
        valueChainMapId, sessionId, unitId, itemId, body,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_ITEM
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{unitId}', `${unitId}`)
          .replace('{itemId}', `${itemId}`),
        method: HTTP_METHODS.PATCH,
        body,
      }),
      onQueryStarted: async ({
        valueChainMapId, sessionId, unitId,
      }, {
        getState, dispatch, queryFulfilled,
      }) => {
        try {
          const { data: updatedResponse } = await queryFulfilled;

          syncUpdatedSupplierDiscoveryItemInCaches({
            valueChainMapApi,
            state: getState() as RootState,
            dispatch,
            valueChainMapId,
            sessionId,
            unitId,
            item: updatedResponse.data,
          });
        } catch {
          // noop
        }
      },
      invalidatesTags: (result, error, {
        valueChainMapId, sessionId, unitId, itemId,
      }) => [
        {
          type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEM_RECORD_TAG,
          id: `${valueChainMapId}-${sessionId}-${unitId}-${itemId}`,
        },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEM_RECORD_TAG,
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG, id: `${valueChainMapId}-${sessionId}-${unitId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG,
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG,
      ],
    }),
    deleteAgentSessionSupplierDiscoveryItem: builder.mutation<
    void,
    IDeleteAgentSessionSupplierDiscoveryItemRequest
    >({
      query: ({
        valueChainMapId, sessionId, unitId, itemId,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_ITEM
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{unitId}', `${unitId}`)
          .replace('{itemId}', `${itemId}`),
        method: HTTP_METHODS.DELETE,
      }),
      onQueryStarted: async ({
        valueChainMapId, sessionId, unitId, itemId,
      }, {
        getState, dispatch, queryFulfilled,
      }) => {
        try {
          await queryFulfilled;
        } catch {
          return;
        }

        syncDeletedSupplierDiscoveryItemInCaches({
          valueChainMapApi,
          state: getState() as RootState,
          dispatch,
          valueChainMapId,
          sessionId,
          unitId,
          itemId,
        });
      },
      invalidatesTags: (result, error, {
        valueChainMapId, sessionId, unitId, itemId,
      }) => [
        {
          type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEM_RECORD_TAG,
          id: `${valueChainMapId}-${sessionId}-${unitId}-${itemId}`,
        },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEM_RECORD_TAG,
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG, id: `${valueChainMapId}-${sessionId}-${unitId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG,
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG,
      ],
    }),
    updateAgentSessionSupplierDiscoverySelection: builder.mutation<
    void,
    IUpdateAgentSessionSupplierDiscoverySelectionRequest
    >({
      query: ({
        valueChainMapId, sessionId, unitId, body,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_SELECTION
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{unitId}', `${unitId}`),
        method: HTTP_METHODS.PATCH,
        body,
      }),
      onQueryStarted: async ({
        valueChainMapId, sessionId, unitId, body,
      }, {
        getState, dispatch, queryFulfilled,
      }) => {
        try {
          await queryFulfilled;
        } catch {
          return;
        }

        syncSupplierDiscoverySelectionInCaches({
          valueChainMapApi,
          state: getState() as RootState,
          dispatch,
          valueChainMapId,
          sessionId,
          unitId,
          isActive: body.isActive,
        });
      },
      invalidatesTags: (result, error, { valueChainMapId, sessionId, unitId }) => [
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG, id: `${valueChainMapId}-${sessionId}-${unitId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG,
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG,
      ],
    }),
    exploreAgentSessionSupplierDiscoveryAi: builder.mutation<
    IAgentSessionBomSessionUnit,
    IExploreAgentSessionSupplierDiscoveryRequest
    >({
      query: ({ valueChainMapId, sessionId, unitId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_EXPLORE_AI
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{unitId}', `${unitId}`),
        method: HTTP_METHODS.POST,
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId, unitId }) => [
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEMS_TAG, id: `${valueChainMapId}-${sessionId}-${unitId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEMS_TAG,
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG, id: `${valueChainMapId}-${sessionId}-${unitId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG,
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG,
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    activateAgentSession: builder.mutation<
    IBaseQueryResponse<ISessionVCItem>,
    IVCAgentSessionApplyRequest
    >({
      query: ({ valueChainMapId, sessionId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_ACTIVATE
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
        method: HTTP_METHODS.PATCH,
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId }) => [
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        { type: VC_AGENT_SESSION_RECORD_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    updateAgentSessionUnits: builder.mutation<
    IBaseQueryResponse<ISessionVCItem>,
    IUpdateAgentSessionUnitsRequest
    >({
      query: ({ valueChainMapId, sessionId, unitIds }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_UNITS
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
        method: HTTP_METHODS.PATCH,
        body: { unitIds },
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId }) => [
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        { type: VC_AGENT_SESSION_RECORD_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    // Agent schedules — Nest `/value-chain-maps/:id/agent-schedules`
    getMonitoringSchedules: builder.query<
    IBaseQueryResponse<IMonitoringSchedule[]>,
    IGetMonitoringSchedulesRequest
    >({
      query: ({ valueChainMapId, sessionType }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SCHEDULES.replace('{valueChainMapId}', `${valueChainMapId}`),
        params: sessionType ? { type: sessionType } : undefined,
      }),
      transformResponse: (
        response: IBaseQueryResponse<Parameters<typeof mapAgentScheduleFromApi>[0][]>,
      ): IBaseQueryResponse<IMonitoringSchedule[]> => ({
        data: (response.data ?? []).map(mapAgentScheduleFromApi),
      }),
      providesTags: (result, error, { valueChainMapId }) => [
        { type: VC_AGENT_MONITORING_SCHEDULES_TAG, id: valueChainMapId },
        VC_AGENT_MONITORING_SCHEDULES_TAG,
      ],
    }),
    getMonitoringScheduleRuns: builder.query<
    IBaseQueryResponse<IMonitoringRun[]>,
    IGetMonitoringScheduleRunsRequest
    >({
      query: ({ valueChainMapId, scheduleId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SCHEDULE_RUNS
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{scheduleId}', `${scheduleId}`),
      }),
      transformResponse: (
        response: IBaseQueryResponse<Parameters<typeof mapAgentScheduleRunFromApi>[0][]>,
      ): IBaseQueryResponse<IMonitoringRun[]> => ({
        data: (response.data ?? []).map(mapAgentScheduleRunFromApi),
      }),
      providesTags: (result, error, { valueChainMapId, scheduleId }) => [
        { type: VC_AGENT_MONITORING_SCHEDULE_RUNS_TAG, id: `${valueChainMapId}-${scheduleId}` },
        VC_AGENT_MONITORING_SCHEDULE_RUNS_TAG,
      ],
    }),
    getMonitoringScheduleExecutions: builder.query<
    IBaseQueryResponse<IMonitoringExecution[]>,
    IGetMonitoringScheduleExecutionsRequest
    >({
      query: ({ valueChainMapId, scheduleId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SCHEDULE_EXECUTIONS
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{scheduleId}', `${scheduleId}`),
      }),
      transformResponse: (
        response: IBaseQueryResponse<Parameters<typeof mapAgentScheduleExecutionFromApi>[0][]>,
      ): IBaseQueryResponse<IMonitoringExecution[]> => ({
        data: (response.data ?? []).map(mapAgentScheduleExecutionFromApi),
      }),
      providesTags: (result, error, { valueChainMapId, scheduleId }) => [
        {
          type: VC_AGENT_MONITORING_SCHEDULE_EXECUTIONS_TAG,
          id: `${valueChainMapId}-${scheduleId}`,
        },
        VC_AGENT_MONITORING_SCHEDULE_EXECUTIONS_TAG,
      ],
    }),
    getMonitoringScheduleExecution: builder.query<
    IBaseQueryResponse<IMonitoringExecutionDetail>,
    IGetMonitoringScheduleExecutionRequest
    >({
      query: ({ valueChainMapId, scheduleId, executionKey }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SCHEDULE_EXECUTION
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{scheduleId}', `${scheduleId}`)
          .replace('{executionKey}', encodeURIComponent(executionKey)),
      }),
      transformResponse: (
        response: IBaseQueryResponse<Parameters<typeof mapAgentScheduleExecutionDetailFromApi>[0]>,
      ): IBaseQueryResponse<IMonitoringExecutionDetail> => ({
        data: mapAgentScheduleExecutionDetailFromApi(response.data),
      }),
      providesTags: (result, error, { valueChainMapId, scheduleId, executionKey }) => [
        {
          type: VC_AGENT_MONITORING_SCHEDULE_EXECUTIONS_TAG,
          id: `${valueChainMapId}-${scheduleId}-${executionKey}`,
        },
        VC_AGENT_MONITORING_SCHEDULE_EXECUTIONS_TAG,
      ],
    }),
    getMonitoringSessionExecutions: builder.query<
    IBaseQueryResponse<IMonitoringExecution[]>,
    IGetMonitoringSessionExecutionsRequest
    >({
      query: ({ valueChainMapId, sessionId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_EXECUTIONS
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
      }),
      transformResponse: (
        response: IBaseQueryResponse<Parameters<typeof mapAgentScheduleExecutionFromApi>[0][]>,
      ): IBaseQueryResponse<IMonitoringExecution[]> => ({
        data: (response.data ?? []).map(mapAgentScheduleExecutionFromApi),
      }),
      providesTags: (result, error, { valueChainMapId, sessionId }) => [
        {
          type: VC_AGENT_MONITORING_SESSION_EXECUTIONS_TAG,
          id: `${valueChainMapId}-${sessionId}`,
        },
        VC_AGENT_MONITORING_SESSION_EXECUTIONS_TAG,
      ],
    }),
    getMonitoringSessionExecution: builder.query<
    IBaseQueryResponse<IMonitoringExecutionDetail>,
    IGetMonitoringSessionExecutionRequest
    >({
      query: ({ valueChainMapId, sessionId, executionKey }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_EXECUTION
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{executionKey}', encodeURIComponent(executionKey)),
      }),
      transformResponse: (
        response: IBaseQueryResponse<Parameters<typeof mapAgentScheduleExecutionDetailFromApi>[0]>,
      ): IBaseQueryResponse<IMonitoringExecutionDetail> => ({
        data: mapAgentScheduleExecutionDetailFromApi(response.data),
      }),
      providesTags: (result, error, { valueChainMapId, sessionId, executionKey }) => [
        {
          type: VC_AGENT_MONITORING_SESSION_EXECUTIONS_TAG,
          id: `${valueChainMapId}-${sessionId}-${executionKey}`,
        },
        VC_AGENT_MONITORING_SESSION_EXECUTIONS_TAG,
      ],
    }),
    getMonitoringRunFindings: builder.query<
    IBaseQueryResponse<IMonitoringRunFindings>,
    IGetMonitoringRunFindingsRequest
    >({
      query: ({ valueChainMapId, runId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_RUN_FINDINGS
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{runId}', `${runId}`),
      }),
      transformResponse: (
        response: IBaseQueryResponse<Parameters<typeof mapAgentRunFindingsFromApi>[0]>,
      ): IBaseQueryResponse<IMonitoringRunFindings> => ({
        data: mapAgentRunFindingsFromApi(response.data),
      }),
      providesTags: (result, error, { valueChainMapId, runId }) => [
        { type: VC_AGENT_MONITORING_RUN_FINDINGS_TAG, id: `${valueChainMapId}-${runId}` },
        VC_AGENT_MONITORING_RUN_FINDINGS_TAG,
      ],
    }),
    runMonitoringScheduleNow: builder.mutation<
    IBaseQueryResponse<{
      scheduleId: string,
      sessionId: string,
      executionKey: string,
      scheduledAt: string,
      runIds: number[],
    }>,
    IRunMonitoringScheduleNowRequest
    >({
      query: ({ valueChainMapId, scheduleId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SCHEDULE_RUN_NOW
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{scheduleId}', `${scheduleId}`),
        method: HTTP_METHODS.POST,
      }),
      transformResponse: (
        response: IBaseQueryResponse<{
          scheduleId: number | string,
          sessionId: number | string,
          executionKey: string,
          scheduledAt: string | Date,
          runIds: number[],
        }>,
      ) => ({
        data: {
          scheduleId: String(response.data.scheduleId),
          sessionId: String(response.data.sessionId),
          executionKey: response.data.executionKey,
          scheduledAt: typeof response.data.scheduledAt === 'string'
            ? response.data.scheduledAt
            : new Date(response.data.scheduledAt).toISOString(),
          runIds: response.data.runIds ?? [],
        },
      }),
      invalidatesTags: (result, error, { valueChainMapId, scheduleId }) => [
        { type: VC_AGENT_MONITORING_SCHEDULES_TAG, id: valueChainMapId },
        VC_AGENT_MONITORING_SCHEDULES_TAG,
        { type: VC_AGENT_MONITORING_SCHEDULE_RUNS_TAG, id: `${valueChainMapId}-${scheduleId}` },
        {
          type: VC_AGENT_MONITORING_SCHEDULE_EXECUTIONS_TAG,
          id: `${valueChainMapId}-${scheduleId}`,
        },
        VC_AGENT_MONITORING_SCHEDULE_EXECUTIONS_TAG,
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    getMonitoringResults: builder.query<
    IBaseQueryResponse<TMonitoringAnySignalResult | null>,
    IGetMonitoringResultsRequest
    >({
      queryFn: ({ sessionId, runId }) => {
        const resultKey = runId ?? (sessionId !== undefined ? `${sessionId}` : '');
        const signals = resultKey ? MONITORING_AGENT_DEMO_SIGNALS[resultKey] ?? null : null;

        return { data: { data: signals } };
      },
      providesTags: (result, error, { valueChainMapId, sessionId, runId }) => [
        {
          type: VC_AGENT_MONITORING_RESULTS_TAG,
          id: `${valueChainMapId}-${runId ?? sessionId ?? 'none'}`,
        },
        VC_AGENT_MONITORING_RESULTS_TAG,
      ],
    }),
    createMonitoringSchedule: builder.mutation<
    IBaseQueryResponse<IMonitoringSchedule>,
    ICreateMonitoringScheduleRequest
    >({
      query: ({
        valueChainMapId, sessionType, subType, agentConfigId, unitIds, title, schedule,
        autoCreateImpactScenario, impactScenarioMinSeverity,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SCHEDULES.replace('{valueChainMapId}', `${valueChainMapId}`),
        method: HTTP_METHODS.POST,
        body: {
          type: sessionType,
          subType,
          agentConfigId,
          title,
          unitIds,
          schedule,
          autoCreateImpactScenario: Boolean(autoCreateImpactScenario),
          impactScenarioMinSeverity: impactScenarioMinSeverity ?? null,
        },
      }),
      transformResponse: (
        response: IBaseQueryResponse<Parameters<typeof mapAgentScheduleFromApi>[0]>,
      ): IBaseQueryResponse<IMonitoringSchedule> => ({
        data: mapAgentScheduleFromApi(response.data),
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VC_AGENT_MONITORING_SCHEDULES_TAG, id: valueChainMapId },
        VC_AGENT_MONITORING_SCHEDULES_TAG,
      ],
    }),
    updateMonitoringSchedule: builder.mutation<
    IBaseQueryResponse<IMonitoringSchedule>,
    IUpdateMonitoringScheduleRequest
    >({
      query: ({
        valueChainMapId, scheduleId, agentConfigId, title, unitIds, schedule,
        autoCreateImpactScenario, impactScenarioMinSeverity,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SCHEDULE
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{scheduleId}', `${scheduleId}`),
        method: HTTP_METHODS.PATCH,
        body: {
          agentConfigId,
          ...(title !== undefined ? { title } : {}),
          ...(unitIds !== undefined ? { unitIds } : {}),
          ...(schedule !== undefined ? { schedule } : {}),
          ...(autoCreateImpactScenario !== undefined
            ? { autoCreateImpactScenario } : {}),
          ...(impactScenarioMinSeverity !== undefined
            ? { impactScenarioMinSeverity } : {}),
        },
      }),
      transformResponse: (
        response: IBaseQueryResponse<Parameters<typeof mapAgentScheduleFromApi>[0]>,
      ): IBaseQueryResponse<IMonitoringSchedule> => ({
        data: mapAgentScheduleFromApi(response.data),
      }),
      invalidatesTags: (result, error, { valueChainMapId, scheduleId }) => [
        { type: VC_AGENT_MONITORING_SCHEDULES_TAG, id: valueChainMapId },
        VC_AGENT_MONITORING_SCHEDULES_TAG,
        { type: VC_AGENT_MONITORING_SCHEDULE_RUNS_TAG, id: `${valueChainMapId}-${scheduleId}` },
        {
          type: VC_AGENT_MONITORING_SCHEDULE_EXECUTIONS_TAG,
          id: `${valueChainMapId}-${scheduleId}`,
        },
      ],
    }),
    pauseMonitoringSchedule: builder.mutation<
    IBaseQueryResponse<IMonitoringSchedule>,
    IPauseResumeMonitoringScheduleRequest
    >({
      query: ({ valueChainMapId, scheduleId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SCHEDULE_PAUSE
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{scheduleId}', `${scheduleId}`),
        method: HTTP_METHODS.PATCH,
      }),
      transformResponse: (
        response: IBaseQueryResponse<Parameters<typeof mapAgentScheduleFromApi>[0]>,
      ): IBaseQueryResponse<IMonitoringSchedule> => ({
        data: mapAgentScheduleFromApi(response.data),
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VC_AGENT_MONITORING_SCHEDULES_TAG, id: valueChainMapId },
        VC_AGENT_MONITORING_SCHEDULES_TAG,
      ],
    }),
    resumeMonitoringSchedule: builder.mutation<
    IBaseQueryResponse<IMonitoringSchedule>,
    IPauseResumeMonitoringScheduleRequest
    >({
      query: ({ valueChainMapId, scheduleId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SCHEDULE_RESUME
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{scheduleId}', `${scheduleId}`),
        method: HTTP_METHODS.PATCH,
      }),
      transformResponse: (
        response: IBaseQueryResponse<Parameters<typeof mapAgentScheduleFromApi>[0]>,
      ): IBaseQueryResponse<IMonitoringSchedule> => ({
        data: mapAgentScheduleFromApi(response.data),
      }),
      invalidatesTags: (result, error, { valueChainMapId }) => [
        { type: VC_AGENT_MONITORING_SCHEDULES_TAG, id: valueChainMapId },
        VC_AGENT_MONITORING_SCHEDULES_TAG,
      ],
    }),
    deleteMonitoringSchedule: builder.mutation<
    null,
    IDeleteMonitoringScheduleRequest
    >({
      query: ({ valueChainMapId, scheduleId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SCHEDULE
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{scheduleId}', `${scheduleId}`),
        method: HTTP_METHODS.DELETE,
      }),
      invalidatesTags: (result, error, { valueChainMapId, scheduleId }) => [
        { type: VC_AGENT_MONITORING_SCHEDULES_TAG, id: valueChainMapId },
        VC_AGENT_MONITORING_SCHEDULES_TAG,
        { type: VC_AGENT_MONITORING_SCHEDULE_RUNS_TAG, id: `${valueChainMapId}-${scheduleId}` },
        VC_AGENT_MONITORING_SCHEDULE_RUNS_TAG,
        {
          type: VC_AGENT_MONITORING_SCHEDULE_EXECUTIONS_TAG,
          id: `${valueChainMapId}-${scheduleId}`,
        },
        VC_AGENT_MONITORING_SCHEDULE_EXECUTIONS_TAG,
      ],
    }),
    importAgentSessionSupplierDiscoveryXlsx: builder.mutation<
    IBaseQueryResponse<IImportAgentSessionSupplierDiscoveryXlsxResponse>,
    IImportAgentSessionSupplierDiscoveryXlsxRequest
    >({
      query: ({
        valueChainMapId, sessionId, unitId, ...body
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_IMPORT_XLSX
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`)
          .replace('{unitId}', `${unitId}`),
        method: HTTP_METHODS.POST,
        body,
      }),
      invalidatesTags: (result, error, {
        valueChainMapId, sessionId, unitId, dryRun,
      }) => {
        if (dryRun) {
          return [];
        }

        return [
          { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEMS_TAG, id: `${valueChainMapId}-${sessionId}-${unitId}` },
          VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEMS_TAG,
          { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG, id: `${valueChainMapId}-${sessionId}-${unitId}` },
          VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG,
          { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG, id: `${valueChainMapId}-${sessionId}` },
          VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG,
        ];
      },
    }),
    exploreAgentSessionBomAllTabsAi: builder.mutation<void, IVCAgentSessionApplyRequest>({
      query: ({ valueChainMapId, sessionId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_BOM_ALL_TABS_EXPLORE_AI
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
        method: HTTP_METHODS.POST,
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId }) => [
        VC_AGENT_SESSION_BOM_RECORD_TAG,
        VC_AGENT_SESSION_BOM_ITEMS_TAG,
        { type: VC_AGENT_SESSION_BOM_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_BOM_TAG,
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    exploreAgentSessionSupplierDiscoveryAllTabsAi: builder.mutation<void, IVCAgentSessionApplyRequest>({
      query: ({ valueChainMapId, sessionId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_ALL_TABS_EXPLORE_AI
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
        method: HTTP_METHODS.POST,
      }),
      invalidatesTags: (result, error, { valueChainMapId, sessionId }) => [
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_ITEMS_TAG,
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_UNIT_TAG,
        { type: VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG, id: `${valueChainMapId}-${sessionId}` },
        VC_AGENT_SESSION_SUPPLIER_DISCOVERY_TAG,
        { type: VC_AGENT_SESSION_LIST_TAG, id: valueChainMapId },
        VC_AGENT_SESSION_LIST_TAG,
      ],
    }),
    getAgentSessionSupplierDiscoveryXlsxExample: builder.query<void, IVCAgentSessionApplyRequest>({
      query: ({ valueChainMapId, sessionId }) => ({
        url: VALUE_CHAIN_MAP_AGENT_SESSION_SUPPLIER_DISCOVERY_XLSX_EXAMPLE
          .replace('{valueChainMapId}', `${valueChainMapId}`)
          .replace('{sessionId}', `${sessionId}`),
        responseHandler: async (response) => downloadFileHandler({
          filename: SHEET_EXAMPLE_FILES_NAME.supplierDiscovery,
          response,
        }),
        cache: 'no-cache',
      }),
    }),
    getValueChainMapBoardStructure: builder.query<IValueChainBoardStructure[], { valueChainMapId: string }>({
      query: ({ valueChainMapId }) => ({
        url: VALUE_CHAIN_MAP_BOARD_STRUCTURE.replace('{valueChainMapId}', valueChainMapId),
        method: HTTP_METHODS.GET,
      }),
      providesTags: [VALUE_CHAIN_MAP_BOARD_TAG],
    }),
    getValueChainMapBoardFilters: builder.query<{ data: IBoardFilter }, { valueChainMapId: string }>({
      query: ({ valueChainMapId }) => ({
        url: VALUE_CHAIN_MAP_BOARD_FILTERS.replace('{valueChainMapId}', valueChainMapId),
        method: HTTP_METHODS.GET,
      }),
      providesTags: [VALUE_CHAIN_MAP_BOARD_TAG],
    }),
    // No tags. A tag invalidation would refetch after every debounced save.
    // The mutations write the same cache entry the next visit reads, so leaving
    // the page and opening it again restores the row that was just saved.
    getValueChainMapUserFilters: builder.query<IGetUserFiltersResponse, { valueChainMapId: string }>({
      query: ({ valueChainMapId }) => ({
        url: VALUE_CHAIN_MAP_USER_FILTERS.replace('{valueChainMapId}', valueChainMapId),
        method: HTTP_METHODS.GET,
      }),
    }),
    saveValueChainMapUserFilters: builder.mutation<IGetUserFiltersResponse,
    { valueChainMapId: string, filters: IUserFiltersPayload }>({
      query: ({ valueChainMapId, filters }) => ({
        url: VALUE_CHAIN_MAP_USER_FILTERS.replace('{valueChainMapId}', valueChainMapId),
        method: HTTP_METHODS.PUT,
        body: { filters },
      }),
      async onQueryStarted({ valueChainMapId }, { dispatch, queryFulfilled }) {
        try {
          const { data } = await queryFulfilled;
          dispatch(valueChainMapApi.util.updateQueryData(
            'getValueChainMapUserFilters',
            { valueChainMapId },
            () => data,
          ));
        } catch {
          // useUserFilters logs the failed request. The cached row stays unchanged.
        }
      },
    }),
    deleteValueChainMapUserFilters: builder.mutation<void, { valueChainMapId: string }>({
      query: ({ valueChainMapId }) => ({
        url: VALUE_CHAIN_MAP_USER_FILTERS.replace('{valueChainMapId}', valueChainMapId),
        method: HTTP_METHODS.DELETE,
      }),
      async onQueryStarted({ valueChainMapId }, { dispatch, queryFulfilled }) {
        try {
          await queryFulfilled;
          dispatch(valueChainMapApi.util.updateQueryData(
            'getValueChainMapUserFilters',
            { valueChainMapId },
            () => ({ data: null }),
          ));
        } catch {
          // useUserFilters logs the failed request. The cached row stays unchanged.
        }
      },
    }),
    getValueChainMapBoardGroups: builder.query<IBoardInstanceGroup[], IGetBoardUnitsRequest>({
      query: ({
        valueChainMapId, boardId, type, filters = '', followConnections,
      }) => {
        const queryParams = [filters, followConnections !== undefined ? `followConnections=${followConnections}` : '']
          .filter(Boolean);

        return {
          url: VALUE_CHAIN_MAP_BOARD_GROUPS
            .replace('{valueChainMapId}', valueChainMapId)
            .replace('{boardId}', boardId)
            .replace('{type}', type)
            + (queryParams.length ? `?${queryParams.join('&')}` : ''),
          method: HTTP_METHODS.GET,
        };
      },
      providesTags: [VALUE_CHAIN_MAP_BOARD_TAG],
    }),
    getValueChainMapBoardUnits: builder.query<IBoardUnit[], IGetBoardUnitsRequest>({
      query: ({
        valueChainMapId, boardId, type, filters = '', followConnections,
      }) => {
        const queryParams = [filters, followConnections !== undefined ? `followConnections=${followConnections}` : '']
          .filter(Boolean);

        return {
          url: VALUE_CHAIN_MAP_BOARD_UNITS
            .replace('{valueChainMapId}', valueChainMapId)
            .replace('{boardId}', boardId)
            .replace('{type}', type)
            + (queryParams.length ? `?${queryParams.join('&')}` : ''),
          method: HTTP_METHODS.GET,
        };
      },
      providesTags: [VALUE_CHAIN_MAP_BOARD_TAG],
    }),
    getEligibleAgentTemplates: builder.query<
    IBaseQueryResponse<IEligibleAgentTemplate[]>,
    {
      valueChainMapId: number,
      uiAgentType?: string,
      type?: string,
      subType?: string,
    }
    >({
      query: ({
        valueChainMapId, uiAgentType, type, subType,
      }) => ({
        url: VALUE_CHAIN_MAP_AGENT_TEMPLATES_ELIGIBLE.replace('{valueChainMapId}', `${valueChainMapId}`),
        params: {
          ...(uiAgentType ? { uiAgentType } : {}),
          ...(type ? { type } : {}),
          ...(subType ? { subType } : {}),
        },
      }),
    }),
  }),
});
export const {
  useGetValueChainMapListQuery,
  useUpdateValueChainItemMutation,
  useDeleteValueChainItemMutation,
  useArchiveValueChainItemMutation,
  useRestoreValueChainItemMutation,
  useGetValueChainMapBusinessModelQuery,
  useLazyGetValueChainMapBusinessModelQuery,
  useGetValueChainMapDetailsQuery,
  useLazyGetValueChainMapDetailsQuery,
  useCreateValueChainMapMutation,
  useDuplicateValueChainMapMutation,
  useLazyCheckValueChainMapStatusQuery,
  useUpdateBusinessStructureStatusMutation,
  useUpdateBusinessStructureOrgPathMutation,
  useGetProfitCentresQuery,
  useGetOwnOperationsQuery,
  useGetValueChainMapBoardQuery,
  useLazyGetValueChainMapBoardQuery,
  useGetProfitCenterDataQuery,
  useGetOwnOperationDataQuery,
  useCreateProfitCenterMutation,
  useUpdateProfitCenterMutation,
  useCreateOwnOperationMutation,
  useUpdateOwnOperationMutation,
  useUpdateBoardColumnMutation,
  useCreateBoardColumnMutation,
  useUpdateBoardUnitMutation,
  useReviewValueChainItemMutation,
  useDeleteBoardColumnMutation,
  useCreateLogicalConnectionMutation,
  useGetLogicalConnectionQuery,
  useUpdateLogicalConnectionMutation,
  useDeleteLogicalConnectionMutation,
  useCreateSupplierConnectionMutation,
  useGetSupplierConnectionQuery,
  useUpdateSupplierConnectionMutation,
  useDeleteSupplierConnectionMutation,
  useCreateServiceConnectionMutation,
  useGetServiceConnectionQuery,
  useUpdateServiceConnectionMutation,
  useDeleteServiceConnectionMutation,
  useCreateManufactureConnectionMutation,
  useGetManufactureConnectionQuery,
  useUpdateManufactureConnectionMutation,
  useDeleteManufactureConnectionMutation,
  useGetOrgStructureValueChainMapQuery,
  useGetBoardColumnNamesQuery,
  useGetVCSuppliersQuery,
  useLazyGetVCSuppliersQuery,
  useGetVCCustomersQuery,
  useLazyGetVCCustomersQuery,
  useCreateCustomerMutation,
  useUpdateCustomerMutation,
  useGetCustomerDataQuery,
  useGetSupplierDataQuery,
  useCreateSupplierMutation,
  useUpdateSupplierMutation,
  useGetProductDataQuery,
  useCreateProductMutation,
  useUpdateProductMutation,
  useGetBalanceSheetAssetsDataQuery,
  useCreateBalanceSheetAssetsMutation,
  useUpdateBalanceSheetAssetsMutation,
  useUidNameTuplesVCQuery,
  useRecordRefsVCQuery,
  useGetVCAgentSessionsQuery,
  useCreateVCAgentSessionMutation,
  useGetVCAgentSessionsIdQuery,
  useLazyGetVCAgentSessionsIdQuery,
  useAddedVCAgentSessionUnitsMutation,
  useStartVCAgentSessionMutation,
  useGetAIDraftUnitsQuery,
  useDeleteDraftSessionUnitsMutation,
  useApplyDraftSessionMutation,
  useDeleteSessionMutation,
  useGetAgentSessionBomQuery,
  useGetAgentSessionBomByIdQuery,
  useGetAgentSessionBomXlsxExampleQuery,
  useLazyGetAgentSessionBomXlsxExampleQuery,
  useImportAgentSessionBomXlsxMutation,
  useUpdateAgentSessionBomMutation,
  useUpdateAgentSessionBomSelectionMutation,
  useGetAgentSessionBomItemsQuery,
  useCreateAgentSessionBomItemMutation,
  useUpdateAgentSessionBomItemMutation,
  useDeleteAgentSessionBomItemMutation,
  useStartAgentSessionReviewMutation,
  useCancelAgentSessionReviewMutation,
  useExploreAgentSessionBomAiMutation,
  useGetValueChainMapAnalysesQuery,
  useCreateValueChainMapAnalysisMutation,
  useDeleteValueChainMapAnalysisMutation,
  useDeleteValueChainMapAnalysisScenarioMutation,
  useGetValueChainMapAnalysisByIdQuery,
  useGetValueChainMapAnalysisScenarioByIdQuery,
  useCreateValueChainMapAnalysisScenarioMutation,
  useUpdateValueChainMapAnalysisScenarioMutation,
  useUpdateValueChainMapAnalysisMutation,
  useStartValueChainMapAnalysisMutation,
  useGetValueChainMapAnalysisScenarioDownstreamQuery,
  useGetValueChainMapAnalysisResultsQuery,
  useLazyGetValueChainMapAnalysisResultsQuery,
  useGetValueChainMapAnalysisResultByIdQuery,
  useGetValueChainMapAnalysisResultDownstreamQuery,
  useCopyValueChainMapAnalysisResultMutation,
  useDeleteValueChainMapAnalysisResultByIdMutation,
  useGetValueChainMapAnalysisScenariosQuery,
  useLazyGetValueChainMapAnalysisScenariosQuery,
  useCopyValueChainMapAnalysisScenariosMutation,
  useGetAgentSessionSupplierDiscoveryQuery,
  useUpdateAgentSessionSupplierDiscoveryMutation,
  useGetAgentSessionSupplierDiscoveryItemsQuery,
  useActivateAgentSessionMutation,
  useUpdateAgentSessionUnitsMutation,
  useGetMonitoringSchedulesQuery,
  useGetMonitoringScheduleRunsQuery,
  useGetMonitoringScheduleExecutionsQuery,
  useGetMonitoringScheduleExecutionQuery,
  useGetMonitoringSessionExecutionsQuery,
  useGetMonitoringSessionExecutionQuery,
  useGetMonitoringRunFindingsQuery,
  useRunMonitoringScheduleNowMutation,
  useGetMonitoringResultsQuery,
  useGetEligibleAgentTemplatesQuery,
  useCreateMonitoringScheduleMutation,
  useUpdateMonitoringScheduleMutation,
  usePauseMonitoringScheduleMutation,
  useResumeMonitoringScheduleMutation,
  useDeleteMonitoringScheduleMutation,
  useImportAgentSessionSupplierDiscoveryXlsxMutation,
  useExploreAgentSessionBomAllTabsAiMutation,
  useExploreAgentSessionSupplierDiscoveryAllTabsAiMutation,
  useGetAgentSessionSupplierDiscoveryXlsxExampleQuery,
  useLazyGetAgentSessionSupplierDiscoveryXlsxExampleQuery,
  useGetValueChainMapBoardStructureQuery,
  useLazyGetValueChainMapBoardStructureQuery,
  useGetValueChainMapBoardFiltersQuery,
  useLazyGetValueChainMapBoardFiltersQuery,
  useGetValueChainMapBoardGroupsQuery,
  useLazyGetValueChainMapBoardGroupsQuery,
  useGetValueChainMapBoardUnitsQuery,
  useLazyGetValueChainMapBoardUnitsQuery,
  useGetValueChainMapUserFiltersQuery,
  useSaveValueChainMapUserFiltersMutation,
  useDeleteValueChainMapUserFiltersMutation,
} = valueChainMapApi;

export default valueChainMapApi;
